var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAspCore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 225,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103 0 L 112.5 0 L 113 1.5 L 111.5 3 L 103 3 L 103 0 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 0 L 121 0.5 Q 118.9 3.8 118.5 0 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 0 L 186 0.5 Q 183.9 3.8 183.5 0 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 0 L 201.5 0 L 202 1.5 L 199.5 3 Q 198.2 0.7 193.5 2 L 192.5 0 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215 0 L 221 0 L 221 2.5 Q 219.6 5.3 215 4 L 215 0 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225 0 Q 228 -1.3 227 2.5 Q 229.3 3.7 226.5 5 L 224 3.5 L 225 0 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 1 Q 256.8 0.2 258.5 3 L 272 4 L 269.5 10 L 268.5 8 L 267 8.5 L 267.5 7 Q 262.9 7.6 261.5 5 L 248.5 5 L 244.5 6 L 240.5 5 Q 239 8.5 237.5 6 Q 234.5 6.7 236 3 L 241.5 2 L 242.5 3 L 251.5 3 L 251.5 1 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 3 L 144 4 L 144 6 Q 141.3 4.9 142 7.5 L 145.5 9 L 147.5 8 L 149 8.5 L 147 3 L 156.5 3 L 157 5.5 L 155.5 8 L 157 8.5 L 153.5 9 L 151.5 8 L 151.5 10 L 149.5 9 L 149.5 11 L 144.5 9 L 135.5 12 L 136.5 9 L 133.5 8 L 133.5 10 L 131.5 9 L 130 9.5 L 133 7.5 L 128 6 L 129.5 3 Z M 138 8 L 138 10 L 140 9 L 138 8 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161 3 Q 170.5 1.8 176 5.5 L 171 7.5 Q 170.3 9.8 172.5 9 L 173.5 13 L 171 12 Q 172.5 8.2 169.5 9 L 166 8 Q 167.1 5.3 164.5 6 L 161 5 L 161 3 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 6 L 209 12.5 L 209 17.5 L 206.5 19 Q 203.8 17.8 206 16.5 L 205 11.5 L 206 9.5 L 205 7.5 L 206.5 6 Z M 208 16 L 206 18 L 208 18 L 208 16 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 7 L 99 7.5 L 99 18.5 L 97 19.5 Q 98 14.5 95 15.5 L 95 8.5 L 96.5 7 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212 7 L 214 7.5 L 213 10 L 209.5 11 L 209.5 10 L 212 8.5 L 212 7 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 8 Q 109.1 7.3 108 10 L 110 10 L 110.5 8 L 116 9.5 L 117.5 12 L 121 14.5 L 118 14.5 L 118.5 13 L 113.5 10 L 111.5 10 L 107 11 L 106.5 8 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125 8 Q 129 6.6 127 13.5 L 131 15.5 L 128.5 16 L 126 15 L 126 20 L 127.5 20 L 130 19 L 127.5 28 L 125 21.5 L 122 18.5 L 122 15 Q 128 17.3 126 10.5 L 125 8 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 8 L 162 8.5 L 159.5 9 L 159.5 8 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 8 Q 188.3 11.1 190 9.5 Q 186.3 10.8 187 15 L 185 15.5 L 187 16 L 186.5 18 Q 184.8 14.3 183 17.5 L 182 26 L 179 24.5 L 177.5 16 L 176 16.5 L 176.5 13 L 177 15 L 184 16 Q 183.3 10.7 186.5 8 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 8 L 193.5 11 L 195 10.5 L 198.5 16 L 202 17.5 L 200.5 20 Q 196.4 17.7 196 13 L 191 11 L 191.5 8 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 8 L 217 12.5 L 215 11.5 L 214 9.5 L 215.5 8 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 8 L 228 10.5 L 224 11 L 223.5 8 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 8 L 236 10.5 L 232 11 L 232.5 8 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 264.5 8 L 266.5 13 L 267.5 11 L 271 15.5 L 268 15.5 L 267.5 13 L 267 17 L 264 16.5 L 266 16 L 264 10.5 L 264.5 8 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 9 L 169 10.5 L 167.5 11 L 165.5 9 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 9 Q 224.5 10.5 221.5 12 L 221.5 9 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 9 L 250 10.5 L 247 11 L 247.5 9 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 9 Q 264.1 8.3 263 11 L 256 10.5 L 261.5 9 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 10 L 175.5 12 L 174.5 10 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 10 L 240.5 12 L 239.5 10 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 11 L 108 12.5 L 106.5 13 L 105.5 11 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 11 L 200 14.5 L 199 14.5 L 197.5 11 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 13 L 105 15 L 107.5 14 L 107 17.5 L 106.5 20 L 105 18.5 L 104.5 13 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 13 L 221 16 L 219 15.5 L 220.5 13 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216 14 L 218 14.5 L 218 16.5 L 218 32.5 L 216.5 35 L 216 14 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 15 L 151.5 17 L 152.5 15 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 16 L 150 18 L 147 18.5 L 152.5 22 L 154.5 16 L 155 23.5 L 155 25.5 L 154.5 28 L 152 26.5 L 154 25.5 L 151 25 L 150.5 28 L 149.5 25 Q 147.3 25.8 148 23.5 L 147.5 22 L 150.5 25 L 152 23.5 L 151.5 22 L 150 22.5 Q 150.8 20.3 148.5 21 Q 144 19 147.5 17 L 149.5 16 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 16 L 243 16.5 L 243 30.5 L 242 31.5 L 242 45.5 L 240.5 48 L 240 46.5 Q 242.3 45.3 241 40.5 L 239 40.5 L 240 36.5 L 236 34.5 L 239 34 Q 240.5 30.2 237.5 31 L 237.5 30 L 239.5 31 L 240 27.5 L 239.5 26 Q 241.8 26.8 241 24.5 L 235 22 L 233.5 25 L 231 24 L 230 21.5 L 231 18.5 L 230.5 17 L 234 17.5 L 232 18.5 L 236.5 21 L 239 20 L 238 17.5 L 240.5 16 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143 17 Q 146 15.8 145 19.5 L 145.5 21 L 144 20.5 L 145 24.5 L 143.5 24 L 140.5 25 L 139.5 23 L 141 23.5 L 143 17 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 17 Q 163.8 17.8 163 21.5 L 161.5 24 L 161.5 17 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165 17 Q 168.8 15.5 168 18.5 L 168.5 20 L 165 19 L 165 17 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246 17 Q 250 15.6 248 22.5 L 248 24.5 L 248 37.5 L 250 40.5 Q 247 42.8 248 48 L 245 46.5 L 246 41.5 L 245 39.5 L 246 37.5 L 246 35.5 L 246 17 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 258 17 Q 260.7 15.9 260 18.5 L 262 18.5 L 262 22 Q 259.3 20.9 260 23.5 L 262 23.5 L 261.5 40 L 261 31 Q 258.3 29.9 259 32.5 L 258 32.5 Q 259.3 24.2 257 19.5 L 258 17 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202 19 L 206 20.5 Q 204.8 23.3 203.5 21 Q 200.9 21.7 202 19 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 20 L 106 22.5 L 101.5 33 L 102 31.5 L 103 26.5 L 102 24.5 L 104.5 20 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96 21 Q 99 19.8 98 23.5 L 99 27.5 L 98 31 Q 93.9 32.7 95 28.5 L 96 27.5 L 96 21 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 22 L 116 28.5 L 113 27.5 L 114 29.5 L 110.5 31 L 111 27.5 L 111.5 26 L 113 26.5 L 112.5 22 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 22 L 169 24.5 L 167.5 27 L 167 25.5 L 168.5 22 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 22 L 204 25.5 L 201 23.5 L 202.5 22 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 24 L 177 26.5 L 176 26.5 L 176.5 24 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 24 L 209 27.5 L 206.5 31 L 206 29.5 L 206 27.5 L 206.5 26 L 208 26.5 L 208.5 24 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 25 L 196.5 30 L 198 29.5 Q 194.4 32.6 196 40 L 194 39.5 L 194 32 L 196 31.5 L 194 30.5 L 194 28.5 L 195 26.5 L 194.5 25 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 26 Q 123.8 25.3 123 27.5 L 121.5 26 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 28 L 132.5 30 L 131.5 28 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 28 L 181.5 30 Q 178.7 30.7 180.5 28 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 29 Q 132.5 30.5 129.5 32 Q 127.3 32.8 128 30.5 L 129.5 29 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 29 L 174 30.5 L 173.5 32 L 173 30.5 L 174.5 29 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 30 L 124.5 32 L 123.5 30 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 31 L 139.5 33 L 138.5 31 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 31 L 235 31.5 L 231.5 32 L 231.5 31 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 32 L 97.5 32 L 100.5 34 L 100 35.5 L 99.5 38 L 98.5 34 L 97.5 36 L 97 34 Q 93.8 35 95.5 32 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 32 L 168 34 L 165 34 Q 166.1 36.7 163.5 36 L 164 37.5 L 165 39.5 L 163.5 40 L 161.5 39 L 160 39.5 L 161 34 L 167.5 32 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179 32 L 184.5 33 L 187 32 L 186.5 35 L 183.5 34 L 181 37.5 L 185 40.5 L 184.5 42 L 186.5 41 L 185 43.5 L 184.5 45 L 181.5 39 L 178.5 38 L 176 39 L 175.5 45 L 175 43 Q 172.3 44.1 173 41.5 L 170 39.5 L 171 37 L 174.5 35 L 176 38 Q 178.7 39.1 178 36.5 L 179 32 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 32 L 230 35.5 L 229 39 L 231 39.5 L 228 40 L 228.5 32 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 33 L 126.5 37 L 131.5 34 L 133.5 35 L 135.5 34 L 135.5 36 L 137 36.5 L 134 38.5 L 137 39.5 L 134.5 40 L 131.5 38 L 129.5 41 L 127 40.5 Q 124 37.8 125.5 33 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 33 L 154 39 L 150.5 40 L 151 38.5 L 152 36.5 L 151.5 33 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138 34 L 143 34.5 L 140.5 36 L 138 35.5 L 138 34 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 35 Q 202.8 34.3 202 36.5 L 202.5 38 L 200.5 35 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 37 L 110.5 39 L 111 37 L 113 37.5 Q 109.9 39.3 111.5 41 Q 107.9 39.9 109.5 37 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 37 L 140 39.5 L 138 38.5 L 138.5 37 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 38 L 120 43.5 L 122 45.5 L 120 46.5 Q 122.5 45 119 43.5 L 118.5 38 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 39 L 207 40 Q 208.1 42.7 205.5 42 L 202.5 39 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216 40 L 218 40 Q 216.9 42.7 219.5 42 L 221 41.5 L 220 43.5 L 220.5 45 L 219 45.5 L 221 46 L 220.5 48 L 217.5 47 L 214.5 48 L 213 46.5 L 216 44.5 L 216 42.5 L 216 40 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257.5 40 L 258 42.5 L 257 42.5 L 257.5 40 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110 42 L 114 42 L 114 43.5 L 116 49.5 L 114 50 L 113.5 52 L 113 49 L 111 49 Q 112.1 46.3 109.5 47 L 110.5 45 L 111.5 47 L 112 44 Q 109 45 110 42 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 42 L 156 44.5 L 155.5 46 L 158 46.5 L 152 49 Q 151 44.8 154 45.5 L 154.5 42 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161 42 L 164 43.5 L 165 48 L 160 48 L 160 44.5 L 161 42 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 42 L 194 44.5 L 193 44.5 L 193.5 42 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 43 L 108 44.5 L 106.5 45 L 105.5 43 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 259.5 43 L 261.5 47 L 262.5 44 L 263 48 Q 256.4 50.1 259.5 43 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 44 L 131 45.5 L 129.5 46 L 128.5 44 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 44 L 151 45.5 L 149 46.5 L 150.5 44 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 45 L 198 47.5 L 197 47.5 L 197.5 45 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 45 Q 204.3 44 203 47 L 200.5 46 L 199.5 48 L 199 46.5 L 200.5 45 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 45 L 210 45.5 L 209.5 48 L 207 47 L 207.5 45 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 255.5 45 Q 258.1 44.2 257 47.5 L 256 47.5 L 255.5 46 L 254 46.5 L 255.5 45 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 46 L 98.5 47 L 101.5 46 L 103.5 47 L 105 46.5 L 102.5 48 L 98.5 48 L 96.5 46 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134 46 L 137.5 48 L 147.5 49 L 152.5 52 L 160 52 L 159.5 54 L 148.5 54 L 145 53 L 143.5 50 L 129.5 50 L 129 48 L 134 48 L 134 46 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 46 Q 184.8 45.3 184 47.5 L 180.5 49 L 179.5 47 L 182.5 46 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190 46 L 192 46.5 L 190 47.5 L 190 46 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 46 L 224.5 48 L 223.5 46 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 46 L 233.5 48 L 232.5 46 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 46 Q 253.8 44.9 253 47.5 L 253.5 49 L 250.5 47 L 250.5 46 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 54 L 133.5 55 L 134.5 54 L 144 54 L 142.5 58 Q 137.8 59.3 136.5 57 L 134.5 57 L 129.5 56 L 129.5 58 Q 127.3 58.8 128 56.5 L 130.5 54 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 56 L 168 56.5 L 161.5 57 L 161.5 56 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 57 L 126.5 58 L 128 59.5 Q 126.6 62.1 122 61.5 L 124 62.5 L 122.5 63 L 120 61.5 L 122 60.5 L 120 59.5 L 122 58.5 L 120.5 57 Z M 125 59 L 125 60 L 127 60 L 125 59 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 59 L 143.5 61 L 142 60.5 L 144.5 59 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 59 L 152 59.5 L 147.5 61 L 147.5 60 L 150.5 59 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 60 L 139 60.5 L 134.5 61 L 134.5 60 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 60 L 157 60.5 L 153.5 62 L 153.5 61 L 155.5 60 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 60 L 160 61.5 L 158 62.5 L 159.5 60 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 63 L 99.5 63 L 102 64.5 L 95.5 67 L 94.5 66 L 86 66 L 86.5 64 Q 88.3 66.8 94.5 65 L 94.5 64 L 88.5 64 L 88.5 63 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 63 L 120 63.5 L 117.5 64 L 117.5 63 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 63 Q 164.3 62.3 165 64.5 L 163.5 64 Q 159.5 64.8 160.5 63 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 64 L 112 65.5 L 106.5 69 L 105.5 68 L 103 69.5 L 108 66.5 L 109.5 64 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 64 Q 188.8 61.8 187 67 Q 181.4 66 180 70.5 L 179.5 72 L 178.5 69 L 177 69.5 L 177.5 67 L 182 68 L 181.5 65 L 179.5 66 L 179.5 65 L 181.5 64 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 65 L 172 65.5 L 169.5 67 L 170.5 65 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 65 L 174.5 67 L 172.5 68 L 173.5 66 L 175.5 65 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 69 Q 192.8 68.3 192 70.5 L 193 71.5 Q 189.9 73.3 191.5 75 L 188.5 73 L 186 74.5 L 190.5 69 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80 70 L 83 71.5 L 82 77.5 L 83.5 81 L 85 80.5 L 84.5 82 Q 86.8 81.3 86 83.5 L 84 84.5 L 84 82 L 80 80 L 82 83.5 L 79 82.5 Q 77.8 88.6 80.5 88 L 82 87.5 L 79.5 92 L 77.5 88 L 75 92.5 L 77 95.5 L 75 96 L 73.5 92 L 72.5 94 L 72 89.5 L 74 89.5 L 74 81 L 78.5 81 Q 81.5 80.5 81 76.5 L 80 70 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 70 L 99.5 73 L 101.5 70 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181 71 Q 183.7 69.9 183 72.5 L 183.5 74 L 181 73 L 181 71 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 72 L 97.5 74 L 96.5 72 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 72 L 144 72.5 L 129.5 74 L 127.5 76 L 125 74.5 L 126.5 74 L 128 74.5 L 128.5 73 L 135.5 73 L 136.5 72 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 73 L 95 73.5 Q 92.9 76.8 92.5 73 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 73 Q 153 72 154 74.5 L 150.5 74 Q 147.5 74.5 148.5 73 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 74 L 93 76.5 L 90.5 80 L 89.5 77 L 88 76.5 L 90 75.5 L 89.5 74 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 75 L 161 78 L 163 78.5 L 159.5 80 L 159.5 79 L 161 78.5 L 159 78 L 159.5 75 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 75 L 192 79.5 L 188.5 77 L 187 77.5 L 188.5 75 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 76 Q 121.1 75.3 120 78 L 116.5 80 L 114.5 80 L 111.5 81 L 111 79 L 115 79 L 115 77.5 Q 116.8 79.1 118.5 76 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 77 L 128.5 78 L 143.5 78 L 145.5 77 L 155 79.5 L 128 80 L 127.5 77 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 78 L 168.5 80 Q 165.7 80.7 167.5 78 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 79 L 89 81 L 87 80.5 L 88.5 79 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 80 L 197 81.5 L 195.5 82 L 194.5 80 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 81 L 172.5 82 Q 173.8 79.8 175 82.5 L 173 82.5 Q 172.1 85.5 176.5 84 L 176.5 85 Q 172.8 85.8 172 83.5 Q 172.8 81.3 170.5 82 L 170.5 81 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 81 L 195 84.5 L 193 85.5 L 194 83.5 L 192.5 81 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 82 L 199 83.5 L 200 85.5 L 198.5 85 Q 195.9 85.7 197 83 L 199.5 82 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 84 L 170 85.5 L 168 86.5 L 169.5 84 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 85 L 106.5 86 L 108 85.5 L 105.5 87 L 103.5 85 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 85 L 112 86 L 112 91 L 110 91 L 109.5 85 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161 86 L 170 93.5 L 170 95 L 166 95 Q 166.8 91.2 163.5 90 Q 158.9 91.2 161 86 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 86 L 197 86.5 L 194.5 88 L 195.5 86 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 87 L 98.5 91 L 96.5 92 L 96 90.5 L 101.5 87 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 87 L 193 90 L 189.5 91 L 190.5 89 Q 193 89.7 192.5 87 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181 88 L 183 88 Q 181.9 90.7 184.5 90 L 188 91.5 Q 186.5 95.9 189.5 95 L 189.5 96 L 186 95 L 185.5 97 L 184 94.5 L 187 92.5 L 185.5 92 L 183.5 92 Q 181.3 92.8 182 90.5 L 181 88 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177 90 Q 179.7 88.9 179 91.5 L 177.5 94 L 177 90 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 92 L 78.5 94 Q 75.7 94.7 77.5 92 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 93 Q 107 92 108 94.5 Q 108.8 96.8 106.5 96 L 102.5 97 L 101 94.5 L 102.5 93 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92 94 L 95 95.5 L 93 95.5 L 92.5 97 L 92 94 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 95 L 71 99 L 67 97.5 L 69.5 95 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 95 L 196 96.5 L 196 98 L 192 98 L 193.5 95 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 96 L 204.5 97 L 205.5 96 L 213.5 96 L 213.5 97 L 209.5 98 L 207.5 97 L 207.5 99 L 205.5 98 L 205 101 L 201.5 102 L 199.5 102 L 196 101.5 L 200 101 Q 198.8 98 202.5 99 L 202.5 98 L 200 97.5 L 201.5 96 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233 96 Q 238.6 93.8 237 99.5 L 234.5 101 Q 232 99.8 233 96 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 96 L 249.5 97 L 253.5 96 L 254.5 98 L 251.5 97 Q 250 100.5 248.5 98 Q 245.7 98.7 247.5 96 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 276.5 96 Q 283.4 94 282 98 L 276.5 97 L 276.5 96 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 263.5 97 L 273 98.5 L 272.5 100 L 274 100.5 L 271.5 101 L 269.5 101 L 265.5 100 L 264 100.5 L 264.5 99 L 261.5 101 L 257 100 Q 255.6 96 262.5 98 L 263.5 97 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 98 L 73.5 100 L 72.5 98 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 98 L 227 98.5 L 226.5 100 L 231 101.5 L 228.5 103 L 223.5 98 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 99 L 96 99.5 L 97 104.5 L 94.5 108 L 93 108 L 93 112 L 91.5 112 L 89.5 112 L 86 110.5 L 87.5 111 Q 89.8 111.8 89 109.5 Q 92.7 108.2 92 104 L 94 103.5 L 92.5 101 L 94 101.5 L 93.5 99 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 99 L 188.5 101 Q 185.7 101.7 187.5 99 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 99 Q 222.3 98.3 224 100.5 L 222.5 101 L 218.5 100 L 213.5 102 L 214.5 100 L 217.5 99 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240 99 L 245 99 L 245 101.5 L 244 104 Q 241.3 102.9 242 105.5 L 241 105.5 L 240 99 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283 99 Q 287.6 97.8 289 100.5 L 287.5 103 Q 283.5 103.5 283 100.5 L 283 99 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 101 L 90 101.5 L 81.5 115 L 81 112 Q 83.7 113.1 83 110.5 L 83 108.5 L 86 105.5 L 87.5 101 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64 102 Q 66.7 100.9 66 103.5 L 65 104.5 L 68.5 108 L 69.5 106 L 70 108.5 L 68.5 112 L 67.5 109 L 66.5 113 L 65.5 111 L 64 111.5 L 63 105.5 L 64 102 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 102 L 192 102.5 L 190 110.5 L 191 111.5 L 191 170.5 L 190 170.5 L 189.5 112 L 188.5 171 L 187.5 113 L 186.5 160 L 185.5 112 L 185 158.5 L 183.5 160 L 177 160 L 177 156.5 L 176 152 L 179 152 L 179 144 Q 175.7 142.7 177 147.5 Q 175.6 150.3 171 149 Q 170 145.2 172.5 144 L 176 144 L 176 128.5 L 179 127.5 L 179 113.5 L 182.5 113 Q 185.4 111.4 184.5 106 L 186 106.5 Q 187.1 103.2 184.5 104 L 184.5 103 L 188.5 104 L 190.5 102 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 102 L 204 106 L 202 105.5 L 203.5 102 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 102 L 251 103.5 L 249.5 104 L 248.5 102 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 103 L 207.5 106 L 209.5 103 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 103 L 232 104.5 L 231 106.5 L 231.5 108 L 228 106.5 L 231 104.5 L 231.5 103 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 279.5 103 L 282 104.5 L 281.5 106 L 279.5 103 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 104 L 133 104.5 L 130.5 105 L 130.5 104 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 104 Q 141.3 102.7 140 106 Q 135.8 106 136.5 104 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 104 L 149 106 L 147 105.5 L 148.5 104 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 285.5 104 Q 288.5 105.5 285.5 107 L 285.5 104 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 105 L 145 107.5 L 143.5 108 Q 140.5 106.5 143.5 105 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 106 L 244.5 108 Q 241.7 108.7 243.5 106 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 107 L 138 107.5 L 134 109 L 132.5 112 L 132 109 L 134 108.5 L 133.5 107 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 107 L 151 107.5 L 148.5 109 L 149.5 107 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 107 L 242 109.5 L 240 109.5 L 241 111.5 L 236.5 113 L 236.5 111 L 235 110.5 L 238.5 108 L 240 108.5 L 240.5 107 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 109 L 142 109.5 L 139.5 110 L 139.5 109 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 109 L 229.5 111 L 228.5 109 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 109 L 290 111.5 L 288 112 L 288.5 109 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 110 L 131 111.5 L 129.5 111 L 128.5 110 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 110 L 151 111.5 L 147.5 112 L 145.5 110 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 111 L 262.5 112 L 271.5 112 L 276 115.5 L 274.5 118 L 271.5 113 L 257.5 113 L 257 116 L 254.5 116 L 254.5 115 Q 257.5 115.7 256 112 L 260.5 112 L 261.5 111 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 112 L 123.5 113 L 126 112 L 125.5 114 L 123.5 114 L 121.5 113 L 120 113.5 L 121.5 112 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216 112 L 222 112.5 L 218 113.5 L 218.5 115 L 212 117 L 212 115 Q 214.7 116.1 214 113.5 L 216 113.5 L 216 112 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 112 L 233 113.5 L 230 114.5 L 230 116.5 Q 230.8 120.3 228.5 121 L 227 120.5 Q 230.8 118.8 227.5 117 L 225 118.5 Q 228 117.3 227 113 L 229.5 112 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298 112 Q 301.7 110.8 300 116 Q 296.3 117.2 298 112 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 113 L 69 114.5 L 67 115.5 L 68.5 113 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 113 L 86 115.5 L 85 115.5 L 85.5 113 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 115 L 124 115.5 Q 121.9 118.8 121.5 115 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 115 L 294 117.5 L 293 119.5 L 295 119.5 L 294 122.5 L 296 127.5 L 295 127.5 Q 295.7 124.9 293 126 L 293 121.5 L 291 117.5 L 293 117 L 293.5 115 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 116 L 225 116.5 L 224 121 Q 221.3 122.1 222 119.5 L 222.5 118 L 220.5 116 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112 117 L 116 118.5 L 114 122.5 L 114.5 124 L 112 123 L 113 120.5 L 112 117 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 117 L 232 118.5 L 231.5 120 L 231 118.5 L 232.5 117 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 117 Q 236.8 116.3 236 118.5 L 234.5 117 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251 117 L 254 117.5 L 250 120.5 L 246.5 128 L 246 126.5 L 251 117 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 118 L 209 119.5 L 207 120.5 L 208.5 118 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 118 L 215 118.5 Q 212.9 121.8 212.5 118 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272.5 118 L 273.5 120 L 272.5 118 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 277.5 118 L 280 121.5 L 278.5 121 L 275 119.5 L 277.5 118 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 120 L 79.5 122 L 80.5 120 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 120 L 163 121 L 164 126.5 L 163 126.5 L 160.5 120 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 120 L 167 124.5 L 166 124.5 L 165.5 122 L 164 122.5 L 165.5 120 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 120 Q 236.1 119.2 235 122.5 L 234 122.5 L 233.5 121 L 233 123.5 L 233.5 125 L 232 121.5 L 233.5 120 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65 122 Q 68 121 67 124 Q 64 125 65 122 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 122 L 207.5 124 L 206.5 122 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272 123 Q 275 122 274 125 Q 271 126 272 123 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 123 Q 305.5 124.5 304 130.5 L 302 129.5 L 302.5 123 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 255.5 124 L 257 126.5 L 256 129 Q 251.9 130.7 253 126.5 L 255.5 124 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280.5 124 L 281 127.5 L 280.5 130 L 278 128.5 L 280.5 124 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 125 Q 67.1 124.2 66 127.5 L 65 127.5 L 64.5 125 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 125 L 116.5 127 L 117.5 125 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209 125 Q 215.1 123.2 217 126.5 L 216.5 128 L 209 128 L 209 125 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 126 L 166.5 128 L 168 127.5 Q 166.5 130.5 165 127.5 L 165.5 126 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 128 Q 230.2 134.5 229 144 Q 225.7 142.7 227 147.5 L 226 150 Q 222.7 151.3 224 146.5 L 223 145.5 L 226 142.5 L 226 129.5 L 227.5 128 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272.5 128 L 275 128.5 Q 272.9 131.8 272.5 128 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 129 L 207 130 L 205 133.5 L 206 135.5 L 204 143 L 206 143.5 L 206 160.5 Q 202.5 162.2 204 168 L 208 169.5 L 205.5 173 L 202 172.5 L 204 171.5 L 203 170.5 L 203 160.5 L 204 159.5 L 204 144.5 L 203 143.5 L 203 133.5 L 204.5 129 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 129 L 233 132.5 L 232 132.5 L 232.5 129 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 131 L 168 133.5 L 167 133.5 L 167.5 131 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 133 L 66 140.5 L 65 140.5 L 65.5 133 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 295.5 133 Q 298 134 297 138.5 L 295 137.5 L 295 135.5 L 295.5 133 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 135 L 115 138.5 L 114 138.5 L 114.5 135 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 136 L 165 139.5 L 164 139.5 L 164.5 136 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 140 L 296 142.5 L 295 142.5 L 294.5 141 L 293 141.5 L 294.5 140 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 142 L 257 142.5 L 251.5 143 L 251.5 142 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280.5 142 L 284 142.5 L 280.5 143 L 280.5 142 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288 142 Q 291 141 290 144 Q 287 145 288 142 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 143 L 247 146.5 L 245 147.5 L 246 144.5 L 245.5 143 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 144 L 115 145.5 L 114 150.5 L 115 150.5 L 116.5 146 L 118 153.5 L 120 155.5 L 117.5 154 L 113.5 155 L 112 152.5 L 115.5 144 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 144 L 166 147.5 L 165 147.5 L 164.5 146 L 162.5 150 L 162 148.5 L 164.5 144 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248 144 Q 252.6 142.8 254 145.5 L 254 147 L 256 147.5 L 256 154.5 L 254.5 157 L 254 154 L 252 153.5 L 253 150.5 L 248 147 L 248 144 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 145 L 66 148.5 L 65 148.5 L 65.5 145 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 146 L 168 149.5 L 167.5 152 L 164.5 151 L 163 151.5 L 164.5 149 L 165.5 151 L 167.5 146 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231 148 Q 234 146.8 233 150.5 L 232.5 153 Q 229.1 152.1 231 157.5 L 230 160 L 227 160 L 227 152 Q 233 154 231 148 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 150 L 79.5 152 L 80.5 150 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 152 L 84 152.5 Q 81.9 155.8 81.5 152 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85 152 L 87 152.5 L 85 153.5 L 85 152 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 152 L 283 152.5 L 280.5 154 L 281.5 152 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 284 152 Q 286.7 150.9 286 153.5 L 287 155.5 L 286.5 160 L 284 158.5 Q 284.8 160.8 282.5 160 L 281 160.5 L 281.5 158 L 286 156 Q 287.1 153.3 284.5 154 L 281 156.5 L 282.5 154 Q 285.1 154.7 284 152 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 287.5 152 L 292.5 153 L 295.5 152 L 295.5 153 L 294 153.5 Q 296.7 154.6 296 158 Q 293.3 159.1 294 156.5 Q 296.3 155.3 293.5 154 L 291 154.5 Q 293.8 155.6 293 159 L 296 159.5 L 293 162.5 L 292 168.5 L 290.5 170 L 288 171.5 L 287 173.5 L 287.5 175 L 285.5 176 L 285.5 173 L 287 172.5 L 285 171.5 L 288 171 Q 286.3 166.9 290.5 168 L 290 166.5 L 291 161.5 L 290.5 158 L 292 158.5 L 290.5 155 L 288.5 158 L 288 156.5 Q 291.8 154.8 288.5 153 L 287.5 152 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 153 L 66 155 Q 69 154 68 157 Q 65.3 158.1 66 155.5 L 65.5 153 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 153 L 249 155 L 251 155.5 L 249.5 156 L 248.5 153 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 154 L 81 156.5 L 80 156.5 L 80.5 154 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 156 L 162.5 158 L 163 156 Q 166 154.8 165 158.5 L 163.5 160 L 160 158.5 L 161.5 156 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 157 L 119 158 L 118.5 160 L 116.5 157 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 255.5 158 L 255 159.5 L 256 162.5 L 255 162.5 L 254 159.5 L 255.5 158 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 159 L 69 159.5 L 66.5 161 L 67.5 159 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 159 L 93 159 L 93 162.5 Q 97.8 164.5 96 172 Q 93.3 173.1 94 170.5 L 93 165 L 89 163.5 L 88 159 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 159 L 239 163.5 L 239 167.5 L 238 167.5 Q 238.8 164.9 235.5 166 Q 233.8 169.8 232 166.5 Q 231 162 233.5 161 L 235.5 162 L 236 160.5 L 235.5 159 Z M 234 163 Q 231 167 235 166 L 234 163 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 160 L 66 163.5 L 64 164.5 L 65 162.5 L 63 161.5 L 64.5 160 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 160 L 160 163.5 Q 158.8 166 155 165 Q 152.9 159.8 157.5 161 L 158.5 160 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257.5 160 Q 261.8 163.7 271.5 162 L 273 161.5 L 272.5 163 L 276 163.5 L 271.5 165 L 268.5 163 L 264.5 165 L 262.5 165 L 260 165 L 260 163 Q 257.3 164.1 258 161.5 L 257.5 160 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302 160 L 304 160 L 304 165 L 302 165 L 302 160 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 161 L 69.5 163 L 67 162.5 L 68.5 161 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82 161 Q 84.7 159.9 84 162.5 Q 86.3 163.8 83.5 165 L 82 161 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 161 L 150.5 164 L 148 162.5 L 150.5 161 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 163 L 147 163.5 L 144.5 164 L 144.5 163 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 165 L 70 167 Q 73 165.8 72 169.5 L 76 176.5 L 75 179 L 73 178.5 L 75 175.5 L 72.5 172 L 70.5 171 L 70 176 L 66 176 L 66 174.5 L 68.5 171 Q 71.1 171.8 70 168.5 L 69.5 165 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 165 L 92 176.5 L 90.5 176 Q 88.3 176.8 89 174.5 L 85 167.5 L 85.5 165 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135 165 L 137 165.5 L 135 166.5 L 135 165 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 165 L 148 167.5 L 145.5 168 L 143.5 165 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 165 L 294 167.5 L 293 167.5 L 293.5 165 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 166 L 130.5 167 L 132 166.5 L 132 168 L 128 168 L 128.5 166 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225 166 L 230 168 L 230 170 Q 232.7 168.9 232 171.5 L 234 171.5 L 234 173.5 L 234 175 L 230 175 L 230 170 L 226.5 170 L 225 166 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 166 Q 245 168 241.5 170 L 240 169.5 L 242 168.5 L 240 168 L 240.5 166 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185 168 Q 189 166.6 187 173.5 L 190 175 Q 191.3 179.1 188 178 L 188 181.5 L 189.5 184 L 186 182.5 L 185.5 181 L 185 184 L 182.5 185 L 180.5 182 L 176.5 183 L 175 180.5 L 176 178 L 180 179.5 L 181.5 182 L 183 180.5 L 184.5 171 L 185.5 176 L 186 170.5 L 185 168 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 169 L 140.5 169 Q 143 172.2 149 171 L 148 173.5 Q 150.2 174.8 147.5 176 Q 143.1 177.5 144 174.5 L 142.5 173 L 129 173 Q 127.9 169.5 135.5 171 L 135.5 170 L 129.5 170 L 129.5 169 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 170 L 245 172.5 L 243 171.5 L 243.5 170 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 172 L 245 174.5 L 243.5 175 L 241.5 174 L 240 174.5 L 241.5 172 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 172 L 249.5 174 L 247.5 174 L 246 173.5 L 248.5 172 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 172 L 284 174.5 L 281.5 176 Q 278.5 174.5 281.5 173 L 283 173.5 L 283.5 172 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 173 L 195 174.5 L 192.5 175 L 191.5 173 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 174 L 202 174.5 L 197.5 177 L 196.5 175 L 200.5 174 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 174 L 252.5 176 L 251.5 174 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 175 L 258.5 176 L 273.5 176 L 275.5 175 L 275.5 176 L 273.5 177 L 257.5 177 L 256.5 175 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 176 L 112 176 L 112 184 L 109 184.5 L 112 186.5 L 110.5 187 L 108.5 186 L 108.5 188 L 107 185.5 L 109 179.5 L 108 177.5 L 109.5 176 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 177 L 95 179.5 L 93 178.5 L 93.5 177 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 178 L 78.5 182 L 80 181.5 Q 77.8 182.8 80.5 184 L 82 183.5 L 85 187.5 L 81.5 189 L 82 187.5 Q 83.1 184.2 80.5 185 Q 78.8 181.9 77 183.5 L 77.5 182 L 75.5 183 L 75 181 L 77 180.5 Q 74.8 179.3 77.5 178 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 180 L 73.5 182 L 72.5 180 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 182 L 103 185 L 103.5 187 L 104.5 185 L 106 189 L 108 189.5 L 106.5 190 L 103 188.5 Q 103.8 186.3 101.5 187 L 96 184 L 96.5 182 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 184 L 171.5 187 L 175.5 188 L 177 187.5 L 175.5 191 L 175.5 189 Q 172.2 187.9 173 190.5 L 173.5 192 L 171.5 191 L 171.5 193 L 168.5 195 L 166.5 195 L 165 194.5 L 168.5 192 L 170 192.5 Q 170.8 190.3 168.5 191 L 168.5 190 Q 172.3 190.8 173 188.5 L 169.5 188 L 168 188.5 Q 167.3 186.3 169.5 187 L 169 185.5 L 169.5 184 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 184 Q 176.1 183.2 175 186.5 L 174 186.5 L 173.5 184 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 184 L 197 186.5 L 195.5 187 L 192.5 185 L 191 185.5 L 192.5 184 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 184 L 200 185.5 L 198.5 186 L 197.5 184 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 187 L 78 190 L 77.5 192 L 70 192 L 71 188.5 L 70.5 187 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 187 L 197 189 L 196.5 192 L 195.5 190 L 191.5 196 L 189.5 195 L 189.5 197 Q 187.3 197.8 188 195.5 L 192 192.5 L 194 189.5 L 192.5 187 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 187 L 200 190.5 L 198 191 L 198.5 187 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110 188 Q 112.7 186.9 112 189.5 L 111.5 193 L 114 194.5 L 112.5 194 L 109 192.5 L 111 191.5 L 109 190.5 L 110 188 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 189 L 85 189.5 L 81.5 192 L 83.5 189 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 191 Q 89.5 190.5 90 193.5 Q 89.2 196.1 92.5 195 L 95.5 199 L 101 201.5 L 99 202.5 Q 99.8 200.3 97.5 201 L 90.5 196 L 90.5 198 L 89.5 195 L 84 192.5 L 85.5 191 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 191 L 164 193.5 L 164 195.5 L 161.5 198 L 154.5 200 L 152.5 200 L 148 199.5 L 153.5 198 L 155 198.5 Q 154.3 196.3 156.5 197 L 158.5 197 L 163 195.5 L 156 192.5 L 160.5 191 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123 192 L 125.5 193 L 127.5 192 L 127.5 193 L 126 193.5 L 144 194 L 144.5 192 L 153 192 L 153 194 L 144.5 194 L 144 197 L 141.5 197 L 140.5 198 L 128.5 198 L 127.5 199 L 127 196.5 L 125.5 194 L 123 194.5 L 125 195 L 124.5 199 L 122 194.5 L 123 192 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 192 L 155 194.5 L 154 194.5 L 154.5 192 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 194 L 120 195 L 119.5 197 L 116.5 196 Q 113.7 196.7 115.5 194 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 198 L 184 200.5 L 182 201.5 L 183.5 198 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80 199 L 88.5 202 L 95 202 Q 96.8 206.9 90.5 205 L 89.5 204 L 80 204 L 80 199 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 200 L 136 200.5 L 133.5 201 L 133.5 200 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 200 L 147 200.5 L 144.5 201 L 144.5 200 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 201 Q 193.7 199.9 192 204 L 188 204 L 188 202.5 L 189.5 201 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 204 L 107 205.5 L 105 206.5 L 106.5 204 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 204 L 175.5 206 L 174.5 204 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 204 L 182.5 206 Q 183.7 203.8 185 206.5 L 184.5 208 L 182 207 L 181.5 209 L 175 207.5 L 181 206 L 181.5 204 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 205 L 113 207.5 L 110.5 208 L 108.5 207 L 107 207.5 L 108.5 205 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 205 L 173 206.5 L 171 207.5 L 172.5 205 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 206 L 99 207.5 L 97.5 208 L 96.5 206 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 207 L 169 207.5 L 165.5 209 L 165.5 208 L 167.5 207 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 208 L 126.5 212 L 128.5 212 L 135 212.5 L 124.5 214 L 122 213 Q 123.1 210.3 120.5 211 Q 116.5 210.5 116.5 208 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 208 L 162.5 210 L 158.5 211 L 158.5 210 Q 162 211 161.5 208 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 210 Q 168.1 209.3 167 212 L 164 211.5 L 165.5 210 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119 212 Q 121.7 210.9 121 213.5 L 122.5 216 L 119 215 L 119 212 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 212 L 143 213.5 L 141.5 214 L 139.5 213 L 138 213.5 L 139.5 212 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 214 L 147.5 216 L 151.5 215 L 153.5 215 L 158.5 216 L 160 215.5 L 158.5 219 L 144 218 Q 142.9 215.3 145.5 216 L 147.5 214 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 214 L 166 214.5 L 163.5 215 L 163.5 214 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129 218 L 142.5 218 L 143 220 L 140.5 221 L 129 221 L 129 218 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 220 L 114 222 L 116 222.5 L 113 223 L 113.5 220 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,96)",
    stroke: "rgb(10,42,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 222 L 159.5 222 L 160 224 L 145 223.5 L 152.5 222 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 11 L 115 11.5 L 110 13.5 L 102.5 34 L 102 32.5 L 108 15.5 L 111.5 11 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 11 L 140 11.5 L 135.5 13 L 136.5 11 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 11 L 169 11.5 L 158.5 12 L 158.5 11 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 11 Q 193.3 10.3 194 12.5 L 192.5 12 Q 188.5 12.7 189.5 11 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 11 L 237 11.5 L 222.5 12 L 222.5 11 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 11 L 264 11.5 L 243.5 12 L 243.5 11 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 13 L 132 15.5 L 131 23.5 L 131.5 25 L 130 24.5 L 130 17.5 L 133.5 13 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 13 L 156 42.5 L 155 42.5 L 155.5 13 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 13 Q 190 14 189 18.5 L 188 18.5 L 187.5 13 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 13 L 210 32.5 L 210 34.5 L 209.5 36 L 205 30.5 L 209 32.5 L 209.5 13 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 13 L 222 43.5 L 221 43.5 L 221.5 13 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 14 L 174.5 16 L 173.5 14 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 15 L 196.5 17 L 195.5 15 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 17 L 171 18.5 L 170.5 20 L 168.5 17 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 18 L 199.5 21 L 197.5 18 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 19 L 114 21.5 L 112 20.5 L 112.5 19 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 19 L 251 22.5 L 250 22.5 L 250.5 19 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 20 L 137 22.5 L 135 21.5 L 135.5 20 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 20 L 189 22.5 L 188 22.5 L 188.5 20 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 20 L 196 23.5 L 193 23.5 L 193 21.5 L 193.5 20 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 21 L 172 23.5 L 168.5 28 L 165 27.5 L 170 25.5 Q 169.3 21.8 171.5 21 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 22 L 121 24.5 L 119 23.5 L 119.5 22 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 24 L 189 42.5 L 188 42.5 L 188.5 24 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 24 L 251 41.5 L 250 41.5 L 250.5 24 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 25 L 141.5 27 L 140.5 25 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 25 L 237 25.5 L 226.5 26 L 226.5 25 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 26 L 118 31.5 L 114.5 32 L 114.5 31 Q 117.1 31.8 116 28.5 L 115.5 26 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 26 L 133.5 28 L 132.5 26 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 26 L 145.5 28 L 147 28.5 L 145.5 29 L 143 27.5 L 145.5 26 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 26 L 203 33.5 L 199 30.5 L 197.5 26 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 30 L 145 34.5 Q 146.3 39.8 143.5 41 L 138.5 42 L 138.5 41 L 144 38.5 Q 145 34 142.5 33 L 139.5 30 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 30 L 150 31.5 L 148.5 32 L 147.5 30 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 35 L 102 36.5 L 98.5 44 L 98 42.5 L 101.5 35 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 35 L 204.5 37 L 203.5 35 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 36 L 106.5 38 L 107.5 36 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 36 L 122 43.5 L 121 43.5 L 118.5 36 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 39 L 137 40.5 L 134.5 41 L 133.5 39 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 39 Q 182.5 38.5 183 41.5 L 180.5 40 L 176.5 42 L 178.5 39 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 40 L 128 42.5 L 126 41.5 L 126.5 40 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 40 L 239 40.5 L 226.5 41 L 226.5 40 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 42 L 211 45.5 L 208 43.5 L 208.5 42 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 45 L 145 46.5 L 143.5 46 L 142.5 45 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 45 L 180.5 47 L 181.5 45 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 45 L 238 45.5 L 224.5 46 L 224.5 45 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 45 L 255 45.5 L 252.5 46 L 252.5 45 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 61 L 149 61.5 L 131.5 62 L 131.5 61 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 62 L 130 62.5 Q 99.7 67.7 84 87.5 Q 75.2 98.2 70 112.5 L 67 125.5 L 66.5 139 L 66 125.5 L 71 107.5 L 84 85 L 87 83.5 Q 86.3 81.3 88.5 82 Q 102 67 125.5 62 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 62 L 159 63.5 L 156.5 64 L 151.5 63 L 151.5 62 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 68 L 176 70.5 L 174.5 70 L 172.5 68 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 71 L 142 71.5 L 138.5 72 L 138.5 71 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 71 L 182 73.5 L 180.5 74 L 178.5 71 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 75 L 188 78.5 L 184.5 76 L 183.5 75 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 82 L 102.5 85 L 98.5 88 L 101.5 84 L 104.5 82 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 90 L 93.5 93 L 95.5 90 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 98 L 87.5 100 L 88.5 98 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 101 L 85.5 103 L 86.5 101 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 101 L 224 101.5 L 212.5 103 L 204 110.5 L 202.5 114 L 202 111.5 L 210.5 103 L 216.5 101 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 258.5 101 L 264 101.5 L 258.5 102 L 258.5 101 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 266.5 101 L 272 101.5 L 266.5 102 L 266.5 101 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 102 L 200 102.5 L 192.5 103 L 192.5 102 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 102 L 257 102.5 Q 245.9 105.9 240 114.5 Q 234.2 121.7 233.5 134 L 233 127.5 L 241 111 L 247 106.5 L 246.5 105 L 248.5 105 L 253.5 102 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 104 L 192 171.5 L 191 171.5 L 191.5 104 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 279.5 104 L 280.5 106 L 279.5 104 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 106 Q 284.8 110.2 287 108.5 L 285.5 110 L 282.5 106 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 111 L 222 111.5 L 216.5 112 L 216.5 111 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 287.5 112 L 288.5 114 L 287.5 112 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 113 L 207.5 118 L 211.5 113 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 113 L 250.5 118 L 254.5 113 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 277.5 115 L 280 118.5 L 278 117.5 L 277.5 115 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280.5 120 L 282 124.5 L 281 124.5 L 280.5 120 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 126 L 283 132 L 246 131.5 L 282 131 L 282.5 126 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 136 L 233 139.5 L 232 139.5 L 232.5 136 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 140 L 67 147.5 L 66 147.5 L 66.5 140 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 143 L 234 149.5 L 233 149.5 L 233.5 143 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 150 L 69 156.5 L 68 156.5 L 67.5 150 Z "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 151 L 236 155.5 L 235 155.5 L 234.5 151 Z "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286.5 158 L 284.5 161 L 280.5 163 L 280.5 162 L 286.5 158 Z "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 159 L 256 163.5 L 253.5 162 L 250.5 159 Z "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 289.5 160 L 290 164.5 L 289 164.5 L 289.5 160 Z "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 162 L 73 167.5 L 71 166.5 L 70.5 162 Z "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 163 L 84 165.5 L 82 164.5 L 82.5 163 Z "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 163 L 249 171.5 L 247.5 172 L 244 170 L 242.5 167 Q 240.3 167.8 241 165.5 L 239.5 163 Z "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 277.5 163 L 279 163.5 L 274.5 165 L 274.5 164 L 277.5 163 Z "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 165 L 273 165.5 L 260.5 166 L 260.5 165 Z "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 168 L 87 171.5 L 85 170.5 L 84.5 168 Z "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 169 L 75 171.5 L 73 170.5 L 73.5 169 Z "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 175 L 77.5 177 L 76.5 175 Z "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 176 L 92.5 180 L 89.5 176 Z "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 180 L 82.5 184 L 79.5 180 Z "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 183 L 180.5 189 Q 172.6 196.1 160.5 199 L 160.5 198 Q 175.8 193.3 185.5 183 Z "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 184 L 192 187.5 L 190 186.5 L 189.5 184 Z "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 185 L 87 189.5 L 86 189.5 L 83.5 185 Z "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 185 L 105 190.5 L 102.5 189 L 98.5 185 Z "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 190 L 92.5 195 L 88.5 190 Z "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 191 L 107.5 193 L 106.5 191 Z "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 191 L 189.5 194 L 191.5 191 Z "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 194 L 114 195.5 L 112.5 196 L 111.5 194 Z "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 195 L 95.5 197 L 94.5 195 Z "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 196 L 119 197.5 L 117.5 198 L 115.5 196 Z "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 196 L 184.5 198 L 185.5 196 Z "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 198 L 126 199.5 L 123.5 200 L 120.5 199 L 120.5 198 Z "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 198 L 180.5 201 L 182.5 198 Z "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 199 L 159 199.5 L 150.5 201 L 150.5 200 L 155.5 199 Z "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 200 L 131 200.5 L 127.5 201 L 127.5 200 Z "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 201 L 149 201.5 L 132.5 202 L 132.5 201 Z "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(1,16,57)",
    stroke: "rgb(1,16,57)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 205 L 169.5 207 L 170.5 205 Z "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 8 L 196 9.5 L 193.5 10 L 192.5 8 Z "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 8 L 211 10 L 213.5 9 L 216 12.5 L 216 41 L 214 40.5 Q 216.3 39.3 215 34.5 L 214 32.5 L 215 31.5 L 215 13.5 L 211.5 11 L 209 12.5 Q 208.3 10.3 210.5 11 L 210 9.5 L 210.5 8 Z "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 9 Q 137.3 10.3 135 11.5 L 134.5 14 L 134 11.5 L 134.5 9 Z "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 9 L 171 10.5 L 169.5 13 L 168.5 9 Z "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 10 L 110.5 12 L 111.5 10 Z "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 10 L 118.5 12 L 117.5 10 Z "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 10 Q 147.3 8.7 146 12 Q 142.2 12.8 142.5 10 Z "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 10 L 157.5 12 L 158.5 10 Z "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 10 L 167 10.5 L 160.5 11 L 160.5 10 Z "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 10 L 191 10.5 L 189 11 L 188 18.5 L 188 20.5 L 189 23.5 L 188 24.5 L 188 42.5 L 188.5 44 L 187 43.5 L 187 24.5 L 187 22.5 Q 188.5 15.5 185.5 16 L 185.5 15 L 188 13.5 Q 185.3 11.8 189.5 10 Z "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 10 L 239 10.5 L 240 13.5 L 239 13.5 Q 239.8 11.3 237.5 12 L 236.5 10 Z "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 11 L 109 14.5 L 106 14.5 L 108.5 11 Z "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 11 L 118.5 15 L 120 14.5 Q 118 19 116 15.5 L 115.5 11 Z "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 11 L 243 13 L 241 12.5 L 242.5 11 Z "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171 12 L 176 14.5 L 174.5 14 Q 169.7 15.3 171 12 Z "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 12 L 199 15.5 L 197 14.5 L 196.5 13 L 196 15 Q 193 16 194 13 L 196.5 12 Z "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 13 L 150 15.5 L 149 15.5 L 149.5 13 Z "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 265.5 13 L 266 15.5 L 265 15.5 L 265.5 13 Z "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 15 L 143.5 15 L 148 18.5 L 146.5 18 L 141.5 17 L 140.5 15 Z "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 15 L 242 15.5 Q 239.6 18.1 233.5 17 L 233.5 16 Q 238.3 17.3 239.5 15 Z "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 16 L 138 17.5 L 135 19.5 L 137.5 16 Z "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 16 L 165 16.5 L 161 17 L 160.5 26 L 160 17.5 L 161.5 16 Z "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 16 Q 177.8 16.8 177 20.5 L 176 20.5 L 175.5 16 Z "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 16 L 208 18 L 206 17.5 L 207.5 16 Z "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 16 L 230 16.5 L 228 17 Q 229.8 23.1 226.5 25 L 226 17 L 228.5 16 Z "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 16 L 246 16.5 L 243.5 17 L 243.5 16 Z "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 16 L 250.5 17 L 252 16.5 Q 250.8 19.2 249.5 17 L 248.5 16 Z "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257.5 16 L 257 17.5 L 256.5 45 L 256 17.5 L 257.5 16 Z "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 16 L 264 16.5 L 260.5 17 L 260.5 16 Z "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 17 L 198.5 18 L 200 17.5 Q 198.8 20.3 197.5 18 L 196.5 17 Z "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 18 L 118.5 20 L 117.5 18 Z "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 20 L 172 20.5 L 169.5 22 L 168.5 20 Z "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 21 L 114 23.5 L 113 23.5 L 112.5 22 L 112 26 Q 109.3 27.1 110 24.5 L 112.5 21 Z "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 21 L 202 22.5 L 200.5 23 L 199.5 21 Z "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 23 L 140 24.5 L 139.5 26 L 138.5 24 Q 136.7 26.5 136.5 23 Z "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 24 Q 145.5 25.5 142.5 27 L 142.5 24 Z "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 24 L 170 26 L 168 25.5 L 169.5 24 Z "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193 24 Q 198.2 21.9 197 26.5 L 194 25.5 Q 192.8 30.2 195 31.5 L 194 32.5 L 193.5 42 L 193 24 Z "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 24 L 207.5 26 L 206.5 24 Z "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 25 L 204 27.5 L 203 27.5 L 202.5 25 Z "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 26 L 240 30 L 238 29.5 L 238 27.5 L 238.5 26 Z "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 27 L 109.5 29 L 110.5 27 Z "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 27 Q 133.8 26.3 133 28.5 L 135 28.5 Q 135.8 30.8 133.5 30 L 131.5 27 Z "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160 27 Q 164.6 25.8 166 28.5 L 160 29 L 160 27 Z "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 27 Q 177.1 26.2 176 29.5 L 174 30.5 L 175 28.5 L 174.5 27 Z "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 29 L 137.5 31 Q 138.8 28.7 140 31.5 L 137.5 32 L 136 30.5 L 136.5 29 Z "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 29 L 150 29.5 Q 148.8 32.3 147.5 30 L 146.5 29 Z "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 30 Q 110.8 29.3 110 31.5 L 108.5 30 Z "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 30 L 173 30.5 L 170.5 32 L 171.5 30 Z "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 30 L 228.5 30 L 237 30.5 L 228 31 L 228 39.5 L 226 40 L 226.5 30 Z "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96 31 L 98 31.5 L 96 32.5 L 96 31 Z "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 31 Q 124.8 30.3 124 32.5 L 125 35.5 L 123 34.5 L 124 33.5 L 122.5 31 Z "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149 32 Q 152.3 30.7 151 35.5 L 151.5 37 Q 148.9 37.8 150 34.5 L 149 32 Z "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 33 L 102.5 35 Q 100.3 34.3 101 36.5 L 100 36.5 L 101.5 33 Z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 33 L 143.5 35 L 142.5 33 Z "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160 33 L 164 33.5 L 161 34 L 160.5 39 L 160 33 Z "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 35 L 110.5 37 L 106.5 39 L 106.5 36 Q 108 38.5 109.5 35 Z "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 36 Q 117.3 34.8 118.5 37 L 120 36.5 Q 118.8 39.3 117.5 37 Q 111.5 38.3 112.5 36 Z "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 36 L 206 38.5 L 205.5 40 Q 203.7 36.9 202 38.5 L 202.5 36 Z "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 36 L 210.5 38 L 209.5 36 Z "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 37 L 127 39.5 L 125 40 L 125.5 37 Z "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 37 L 129.5 39 L 130.5 37 Z "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 38 L 149.5 40 L 150.5 38 Z "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 38 L 180 38.5 L 176.5 41 L 176 39 L 178.5 38 Z "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 40 L 131 44.5 L 129 43.5 Q 129.8 41.3 127.5 42 L 127.5 41 L 129.5 42 L 130.5 40 Z "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137 40 L 141 41.5 L 139.5 41 L 137.5 42 L 137 40 Z "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 40 L 161 43.5 L 160 43.5 L 160.5 40 Z "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 40 L 241 46 L 238 45.5 L 240 45 L 240.5 40 Z "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 41 Q 106.8 40.3 106 42.5 L 105 46 L 102 45.5 Q 106.2 43.2 104.5 41 Z "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 42 L 177 45 L 181 45.5 L 178.5 47 Q 174.8 45.8 176.5 42 Z "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 42 L 216.5 46 Q 212 44 215.5 42 Z "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 43 L 123 44 Q 121.9 46.7 124.5 46 L 127 45 L 127.5 43 L 128 46 L 122.5 48 L 120.5 43 Z "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 43 Q 150.3 42 149 45 L 146.5 46 L 146.5 43 Z "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 43 L 208.5 45 L 209.5 43 Z "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 43 L 224 45.5 L 221 46 L 220.5 43 Z "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 44 L 101 45.5 L 98 46 L 98.5 44 Z "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182 44 L 184 44.5 L 182 45.5 L 182 44 Z "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 45 L 140 46.5 L 136.5 47 L 135.5 45 Z "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 45 L 158 45.5 L 155.5 46 L 155.5 45 Z "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189 45 L 191 45.5 L 189 46.5 L 189 45 Z "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 45 L 214 45.5 Q 211.9 48.8 211.5 45 Z "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 46 L 150.5 48 L 151.5 46 Z "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 60 L 142 60.5 L 139.5 61 L 139.5 60 Z "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 60 L 147 60.5 L 144.5 61 L 144.5 60 Z "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 61 Q 131.8 59.9 131 62.5 L 129.5 62 L 128.5 61 Z "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 61 L 153 61.5 L 150.5 63 L 149.5 61 Z "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 63 L 160.5 65 L 159.5 63 Z "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 64 L 117.5 66 L 116.5 64 Z "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 67 L 107.5 69 L 106.5 67 Z "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 69 L 103.5 71 L 101.5 72 L 102.5 70 L 104.5 69 Z "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 69 L 179 70.5 L 177.5 72 L 175.5 69 Z "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 71 L 138 71.5 Q 134.9 74.5 128 73 L 127.5 75 Q 124.5 73.5 127.5 72 Q 133 73.5 134.5 71 Z "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 71 L 152 72.5 L 144.5 73 L 142.5 71 Z "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 72 L 154.5 74 L 152.5 75 L 153 73.5 L 153.5 72 Z "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 73 L 95 75.5 Q 95.8 77.8 93.5 77 L 96.5 73 Z "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 73 L 124.5 75 Q 121.7 75.7 123.5 73 Z "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 73 L 186 74.5 L 183.5 75 Q 180.7 75.7 182.5 73 Z "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 74 L 121 76 L 117.5 77 L 117 75 L 120.5 74 Z "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 74 Q 162.7 73.3 165 76.5 Q 165.8 78.8 163.5 78 L 159.5 75 L 156.5 75 L 156.5 74 Z "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 76 L 189 77.5 L 189 80 Q 192.8 78.5 192 81.5 L 192.5 83 L 188 79.5 L 189.5 76 Z "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 77 Q 116.1 76.3 115 79 L 112 78.5 L 113.5 77 Z "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 78 L 92.5 80 L 93.5 78 Z "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 80 L 80.5 82 L 81.5 80 Z "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 80 L 88.5 82 L 89.5 80 Z "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 81 Q 177.1 80.3 176 83 L 178.5 83 L 180 85.5 L 178.5 85 L 174.5 81 Z "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 82 L 107.5 83 L 109 82.5 L 106.5 84 L 105.5 82 Z "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 83 L 85.5 85 L 86.5 83 Z "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 84 L 111 84.5 L 108.5 86 L 109.5 84 Z "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 85 L 102.5 87 L 101.5 85 Z "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 85 L 193 86.5 L 192 89 L 187.5 91 L 189.5 88 Q 191.8 88.8 191 86.5 L 192.5 85 Z "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181 86 L 185 88.5 L 183 89.5 Q 183.7 86.9 181 88 L 181 86 Z "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96 88 L 99 88.5 L 96.5 90 L 96 88 Z "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 91 L 93.5 94 L 92 93.5 L 95.5 91 Z "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 94 L 78 95.5 L 75.5 97 L 75.5 96 Q 78 96.7 77.5 94 Z "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 95 L 92 95.5 L 89 97.5 L 90.5 95 Z "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 99 L 89.5 101 L 87.5 101 L 86 100.5 L 88.5 99 Z "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 99 L 229 103.5 L 228.5 105 L 230 105.5 L 228 106.5 L 230 109.5 L 228.5 113 L 227 109.5 Q 225.7 104.8 228 103.5 L 224 101.5 L 224.5 99 Z "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 264.5 99 L 264.5 101 L 267.5 100 L 267.5 101 L 264.5 102 L 262 100.5 L 264.5 99 Z "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 101 L 203 102.5 L 200 103 L 200.5 101 Z "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272 101 Q 276.1 99.7 275 103 Q 270.9 104.3 272 101 Z "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 102 L 93.5 104 L 94.5 102 Z "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 102 L 212.5 104 L 211.5 102 Z "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 276 102 L 279 103.5 L 278.5 105 L 277.5 103 L 276 103.5 L 276 102 Z "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 103 L 252.5 105 L 251.5 103 Z "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 104 L 250.5 106 L 249.5 104 Z "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 106 L 205 107 L 204 109.5 L 204.5 111 L 202 110.5 L 202.5 106 Z "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 106 L 246 107.5 L 243 109 L 242.5 111 L 242 109.5 L 245 108 L 245.5 106 Z "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 109 L 84 109.5 L 81.5 111 L 82.5 109 Z "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 110 L 144 110.5 L 137.5 111 L 137.5 110 Z "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 110 L 264.5 110 L 271.5 111 L 273 112.5 L 271.5 112 L 262.5 112 L 262.5 110 Z "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286 110 Q 289 109 288 112 Q 285 113 286 110 Z "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 111 L 70.5 113 L 68 112.5 L 69.5 111 Z "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 112 L 81 116 L 79 115.5 L 80.5 112 Z "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 112 L 214 115 Q 211.3 116.1 212 113.5 L 213.5 112 Z "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 112 Q 225.8 110.9 225 113.5 L 223.5 113 L 222.5 112 Z "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239 112 L 241 112.5 L 240.5 115 L 239 112 Z "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 289.5 112 L 292 112.5 L 291 114.5 L 292 117 L 290 116.5 L 290 114.5 L 289.5 112 Z "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 274.5 113 L 277 114.5 L 280 120.5 L 279 120.5 L 277.5 118 L 275.5 119 L 276 117.5 Q 277.5 113.1 274.5 114 L 274.5 113 Z "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124 114 L 126 114.5 L 123 116.5 L 124 114 Z "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 115 L 211.5 117 L 208 118 L 206 124 L 204 123.5 L 208.5 117 Q 211 117.7 210.5 115 Z "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 115 L 238.5 118 Q 235.5 116.5 238.5 115 Z "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 115 L 250.5 117 L 251.5 115 Z "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 117 L 122 118.5 L 119 120.5 L 121.5 117 Z "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 118 L 80 120.5 L 78 119.5 L 79.5 118 Z "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 118 L 237.5 120 L 236 119.5 L 237 121.5 L 235 120.5 L 236.5 118 Z "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249 118 L 251 118.5 L 247.5 121 L 247.5 120 Q 250.1 120.7 249 118 Z "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 122 L 79 123.5 L 78 124.5 L 78 148.5 L 79 151.5 L 78 151.5 L 76 133.5 L 77 132.5 L 77 123.5 L 78.5 122 Z "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 122 L 117.5 124 L 118.5 122 Z "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 292.5 124 L 294 126.5 L 292 125.5 L 292.5 124 Z "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 125 L 205 127 L 203 126.5 L 204.5 125 Z "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 125 L 282 129 L 280 128.5 L 281.5 125 Z "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203 128 L 205 128.5 L 202.5 135 L 202 133.5 L 203 131.5 L 203 129.5 L 203 128 Z "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 129 L 247 130.5 L 245 131.5 L 244.5 129 Z "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 129 L 296 136.5 L 295 138.5 L 295.5 140 L 293 138.5 L 293.5 129 Z "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 130 L 282 130.5 L 248.5 131 L 248.5 130 Z "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 133 L 234 136 Q 230.5 137.1 232.5 133 Z "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 136 L 203 170.5 L 204 171.5 L 202 170.5 L 202.5 136 Z "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 140 Q 247.1 139.2 246 142.5 L 244 143.5 L 245 141.5 L 244.5 140 Z "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 140 L 292 141.5 L 250.5 142 L 250.5 141 L 287.5 141 L 288.5 140 Z "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232 142 L 234 142.5 L 232 143.5 L 232 142 Z "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 145 L 233 147.5 L 232 147.5 L 232.5 145 Z "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 145 L 246 149.5 L 245 149.5 L 244.5 145 Z "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 148 Q 69.5 149.5 66.5 151 L 66.5 148 Z "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 150 L 235 150.5 L 232.5 152 L 233.5 150 Z "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 151 L 246.5 153 L 245.5 151 Z "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 153 L 67.5 155 L 68.5 153 Z "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 153 Q 80.8 152.3 80 154.5 L 78.5 153 Z "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 154 L 120.5 156 L 119.5 154 Z "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 156 Q 250.8 155.3 250 157.5 L 250.5 159 Q 248.3 159.8 249 157.5 L 248.5 156 Z "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 157 Q 82.1 156.2 81 159.5 L 81.5 161 L 79.5 157 Z "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 289.5 157 L 291 159.5 L 289 158.5 L 289.5 157 Z "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 160 L 71 161.5 L 69.5 162 L 68.5 160 Z "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237 160 L 239 160.5 L 238.5 162 L 240 162.5 L 238.5 163 L 237 160 Z "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 160 L 283.5 162 L 281.5 162 Q 279.3 161.3 280 163.5 L 278 162.5 L 282.5 160 Z "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256 162 L 260 163 L 259.5 165 L 257.5 164 L 256 164.5 L 256 162 Z "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 164 L 240.5 166 L 239.5 164 Z "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272.5 164 Q 274.8 163.3 274 165.5 L 272.5 164 Z "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 166 Q 85.8 165.3 85 167.5 L 85.5 169 L 83.5 166 Z "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 167 L 243.5 169 L 241 168.5 L 242.5 167 Z "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72 168 L 74 168.5 L 72 169.5 L 72 168 Z "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286 169 L 288 169.5 L 286 170.5 L 286 169 Z "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 284.5 170 L 285 172 L 282 171.5 L 284.5 170 Z "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 171 L 76 172.5 L 74.5 173 L 73.5 171 Z "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 172 L 192.5 174 L 191.5 172 Z "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 172 L 256 174.5 L 254.5 175 L 250.5 174 L 249.5 172 Z "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280.5 172 L 281 174 L 276.5 175 L 277.5 173 L 280.5 172 Z "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195 173 L 197.5 174 Q 198.8 171.8 200 174.5 L 195 175 L 195 173 Z "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257.5 174 L 262 175.5 L 258.5 176 L 257.5 174 Z "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272.5 174 Q 275.1 173.3 274 176 L 268 175.5 L 272.5 174 Z "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 176 Q 79.5 177.5 76.5 179 Q 74.3 178.3 75 180.5 L 74 180.5 L 76.5 176 Z "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 179 L 96 181.5 L 94.5 183 L 91.5 179 Z "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 184 Q 194.5 185.5 191.5 187 L 191.5 184 Z "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 186 L 103 187.5 L 101.5 188 L 100.5 186 Z "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 189 L 90 192.5 L 87 190.5 L 87.5 189 Z "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 192 L 190.5 194 L 191.5 192 Z "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 193 L 171.5 195 L 170.5 193 Z "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 194 L 115 196.5 L 114 196.5 L 114.5 194 Z "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 194 L 189 194.5 L 187 195 L 186.5 197 L 186 195.5 L 187.5 194 Z "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 196 L 121 197.5 L 119 198.5 L 120.5 196 Z "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 197 L 99 198 L 98.5 200 L 96 199 L 96.5 197 Z "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 198 L 122.5 200 L 123.5 198 Z "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 198 Q 160.8 197.3 160 199.5 L 158.5 198 Z "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 198 L 184.5 200 L 185.5 198 Z "
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126 199 L 128 199.5 L 126 200.5 L 126 199 Z "
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 200 L 104 201 L 106 205 L 101 203.5 L 103 202.5 L 100.5 200 Z "
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131 200 L 133 200.5 L 131 201.5 L 131 200 Z "
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 200 Q 150.8 198.9 150 201.5 L 148.5 201 L 147.5 200 Z "
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 201 L 180.5 203 L 179 203.5 L 180.5 206 L 177.5 204 L 177.5 206 L 175 204.5 L 181.5 201 Z "
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 206 L 120 208.5 L 117.5 209 L 113 208 L 113.5 206 Z "
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 206 L 169 206.5 L 162.5 209 L 162.5 208 L 167.5 206 Z "
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 209 L 132 211.5 L 128.5 212 L 126.5 212 Q 121.5 211.8 121.5 209 Z "
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 209 L 157.5 211 L 158.5 209 Z "
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,36,80)",
    stroke: "rgb(12,36,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 210 L 155 210.5 L 152.5 212 L 141.5 213 L 139.5 212 L 135.5 213 L 134.5 211 L 151.5 211 L 152.5 210 Z "
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 0 L 159.5 0 L 161 1.5 Q 159.3 6.3 163.5 5 L 166 6 L 164.5 9 L 161.5 10 L 161.5 8 L 158 8 Q 159.1 10.7 156.5 10 L 157 8.5 L 156 6.5 L 157 3.5 Q 155.8 0.7 154.5 3 Q 149.8 4.3 148.5 2 L 147 5.5 Q 149.3 6.8 146.5 8 L 144.5 7 L 143.5 9 L 142 6 Q 144.7 7.1 144 4.5 Q 143 2 138.5 3 L 134.5 4 L 134.5 3 L 138 2.5 L 126.5 2 L 125.5 1 L 121.5 3 Q 118.5 1.5 121.5 0 Z "
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 0 L 182.5 0 L 184 1.5 L 180.5 3 Q 179 -0.5 177.5 2 Q 166.9 3.4 163.5 0 Z "
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202 0 L 207.5 0 L 208 1.5 L 209.5 3 L 219.5 4 L 222 3 Q 220.7 -1.1 224 0 L 223 2.5 L 226.5 5 L 231 2.5 L 229 1.5 L 234.5 0 L 239 1.5 L 234 2.5 L 236 3 Q 234.5 6.7 237.5 6 Q 239 8.5 240.5 5 L 242 6.5 L 243.5 9 L 245 8.5 L 244.5 11 L 242.5 11 Q 238.8 12.3 240 8.5 L 241 6.5 L 239 7.5 L 238.5 9 L 238 7 L 224 7.5 L 227 8.5 Q 225.3 11.8 223.5 8 L 221.5 9 L 220 8.5 L 221 10.5 L 219 14.5 L 220 16.5 L 220 30.5 L 221 31.5 L 219.5 40 L 218.5 38 L 217.5 40 L 217 33.5 L 219 33.5 L 218 31.5 L 218 14.5 L 217 12 Q 220.3 13.3 219 8.5 L 218 8.5 L 217.5 10 L 212.5 7 L 209.5 8 L 208 4 L 201.5 4 L 201 2.5 L 202 0 Z "
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 0 L 214 0.5 Q 211.9 3.8 211.5 0 Z "
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 266.5 0 L 273 0 L 273 3 L 267.5 3 L 267 1.5 L 266.5 0 Z "
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 1 Q 115.4 4.6 121.5 4 L 124 6.5 Q 126.8 9.5 126 15 L 128 14.5 L 125 4.5 L 127 3.5 L 127.5 8 L 128 6 L 132 7.5 L 129 11.5 L 130 15 L 128 15 L 128 20 L 126 20 Q 128.4 12.9 122 15 L 122 18.5 L 126 23.5 L 122.5 26 L 122.5 24 Q 120.3 24.8 121 22.5 L 119 17.5 L 121 14.5 L 120 11 L 118 10.5 L 120 9.5 L 110.5 8 L 108.5 8 L 106 8.5 L 107 9.5 Q 103.9 11.3 105.5 13 Q 102.5 12.1 104 16.5 L 105 18.5 L 101 27.5 L 102 30.5 L 101 34 L 99 33.5 L 100 30.5 Q 96.5 29 99 27.5 L 98 22.5 L 99 20.5 L 99 18.5 L 99 9.5 L 101 9 L 101.5 16 L 102 7.5 L 103.5 6 L 111 5.5 L 105 5 Q 103.9 1.5 111.5 3 L 113.5 1 Z "
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 1 Q 192 4.3 197 3 Q 195.2 8.3 202.5 6 L 204.5 5 Q 207.3 6.3 205 7.5 L 204 10.5 L 206 15.5 L 205 17.5 L 205.5 19 L 203.5 19 L 201.5 20 L 201 18.5 L 201 16.5 L 200 12 Q 197 13.3 198 9.5 L 198.5 8 L 189.5 8 L 188.5 9 L 186 8 L 184 15.5 Q 188 16.9 187 22 Q 184.3 20.9 185 23.5 Q 187.8 25.2 186 31.5 L 184 32.5 Q 184.5 29.5 177.5 31 L 177.5 32 Q 180.5 31.1 179 35.5 L 176.5 37 L 174.5 35 L 172 36.5 L 173.5 34 Q 175.8 34.8 175 32.5 L 174.5 31 Q 177.5 31.7 176 28 L 180 28 Q 178.9 30.7 181.5 30 L 181.5 28 Q 184.8 29.1 184 26.5 Q 180.5 25 183 23.5 Q 181.5 18 184 16.5 L 177 14.5 Q 180.6 12.6 180 6.5 L 182.5 4 Q 188.6 4.6 190.5 1 Z "
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 1 Q 246.3 -0.7 245 3 Q 239.8 3.3 240.5 1 Z "
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 3 L 179 6.5 L 177 7.5 L 177.5 3 Z "
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 5 L 261.5 5 L 264 6.5 L 256 7.5 L 259 8.5 L 255.5 9 Q 252 6 245 6.5 L 248.5 5 Z "
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 6 Q 177.3 4.3 176 8.5 L 177 12.5 L 176 12.5 L 174.5 9 L 173.5 11 L 171 7.5 L 172.5 6 Z "
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 7 L 95 8.5 L 95 15.5 Q 98.3 14.7 97 20 Q 93.3 21.2 95 16 L 88 16 L 88 8 L 94.5 8 L 95.5 7 Z "
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16 8 L 24 8 L 24 16 L 16 16 L 16 8 Z "
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 8 L 155 9.5 L 152.5 13 Q 148.8 14.3 150 10.5 L 149.5 9 L 152.5 10 L 152.5 8 Z "
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 8 L 210 9.5 L 208.5 10 L 207.5 8 Z "
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260 8 Q 265.2 5.9 264 10.5 L 263 10.5 Q 263.8 8.3 261.5 9 L 260 9.5 L 260 8 Z "
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 270.5 9 L 272 9.5 L 271 12.5 L 272 12.5 L 272.5 11 L 273 17 L 269 16.5 L 272 15.5 L 268 12.5 L 270 12.5 L 269 10.5 L 270.5 9 Z "
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 14 L 152 16 Q 155.3 14.7 154 19.5 L 152.5 22 L 150 17.5 L 151 17.5 L 151.5 19 L 152 16 L 150 15.5 L 151.5 14 Z "
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 17 L 141.5 18 L 143 17.5 L 140.5 23 L 138 19.5 L 138.5 17 Z "
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 17 L 165 19 Q 167.7 17.9 167 20.5 L 168 23.5 L 167 26 L 163 27 L 162.5 24 L 161.5 26 L 161 24.5 L 164.5 17 Z "
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228 17 L 231 18.5 L 230.5 21 L 228 20 L 228 17 Z "
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243 17 L 246 17.5 L 246 19.5 L 246 35.5 L 244 40.5 Q 246.3 41.7 245 46.5 L 246.5 48 L 249 46.5 L 249 44.5 L 249.5 43 L 250 44.5 L 249.5 49 L 242 48.5 L 243 46.5 L 242 45.5 L 242 31.5 L 243 30.5 L 243 17 Z "
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 18 L 239 20 L 236.5 21 L 235.5 19 L 238.5 18 Z "
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 19 L 147 21.5 L 147.5 23 L 150 21.5 L 151 23.5 L 149.5 24 L 144 22.5 Q 143.3 20.3 145.5 21 L 148.5 19 Z "
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248 19 L 250 19.5 L 250 31.5 L 248.5 38 L 248 24.5 L 248 20.5 L 248 19 Z "
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205 21 L 209 22 L 207.5 25 L 205.5 24 L 204.5 27 L 203.5 23 Q 206.1 23.7 205 21 Z "
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 22 L 229 24 L 232 24.5 L 229.5 25 L 228.5 22 Z "
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 22 L 240 23 L 238.5 26 L 235.5 24 L 234 24.5 L 236.5 22 Z "
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 23 L 129 25.5 L 128 25.5 L 128.5 23 Z "
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177 24 L 179 24.5 L 177 25.5 L 177 24 Z "
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 26 Q 127.1 25.2 126 28.5 L 128.5 27 L 130 27.5 Q 124.7 29.7 128.5 32 L 130.5 31 L 132.5 31 L 136 30 L 137 34 L 133.5 33 L 133.5 35 L 131.5 34 L 128.5 35 L 126.5 36 L 124.5 29 L 123 29.5 L 124.5 26 Z "
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 27 L 154 30 L 152 29.5 L 153.5 27 Z "
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 29 Q 209.8 28.3 209 30.5 L 207.5 29 Z "
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 31 L 155 32.5 Q 156.4 39.9 153 42.5 L 154 45 L 151.5 46 L 151.5 44 L 150 43.5 L 152.5 39 Q 155.1 39.8 154 36.5 L 151.5 31 Z "
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 31 L 235.5 32 Q 236.7 29.8 238 32.5 L 235 34.5 L 240 36.5 L 240 40 L 231.5 40 L 229 36.5 L 230.5 31 Z "
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16 32 L 24 32 L 24 48 L 16 48 L 16 32 Z "
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196 32 L 200 33.5 L 200.5 40 L 202 39.5 Q 202.8 41.8 200.5 41 L 201.5 44 Q 199.3 43.3 200 45.5 L 201 48 L 203 48.5 L 193 49 L 193 45 L 194.5 45 L 195 42.5 L 197 36.5 L 196 32 Z M 198 38 L 198 45 L 199 45 Q 200 40 198 38 Z M 197 43 L 196 47 L 196 48 Q 201 50 200 47 L 199 47 L 197 43 Z "
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 33 L 171 33.5 Q 168.9 36.8 168.5 33 Z "
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 258.5 33 L 259 39.5 L 258 39.5 L 258.5 33 Z "
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95 34 Q 97.7 32.9 97 35.5 L 98 37.5 L 97 40.5 L 96 43.5 L 96.5 45 L 95 43.5 L 95 34 Z "
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 34 L 187 35.5 Q 189.1 41.4 184.5 40 L 182 39 Q 181 35.2 183.5 34 Z "
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 35 L 168 36.5 Q 168.8 39.1 165.5 38 L 165.5 39 L 170.5 38 L 170 39.5 L 173.5 44 Q 175.8 43.3 175 45.5 L 178 47.5 L 175.5 49 L 166 49 L 164 40.5 L 165.5 37 L 167 36.5 L 165.5 35 Z "
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 36 Q 140.8 35.3 140 37.5 L 138.5 36 Z "
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 36 Q 145.5 37.5 142.5 39 Q 139.5 37.5 142.5 36 Z "
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 38 L 114.5 38 L 118 39.5 L 119 41.5 Q 116.5 43 120 44.5 L 121 49 L 126 48.5 L 125.5 47 L 128 48 Q 126.7 44.7 131.5 46 L 132.5 48 L 130.5 47 L 128 50.5 L 129.5 50 L 133.5 51 L 137.5 50 Q 138.8 52.3 143.5 51 L 148.5 54 L 155 54.5 L 152 55.5 L 168 57 L 168 59 L 161.5 59 L 161 60.5 L 158.5 59 L 157.5 60 L 148.5 58 L 144.5 59 L 144.5 58 L 146 57.5 L 144 54 L 129.5 54 L 128.5 53 L 128 56 L 125 56.5 L 128.5 59 L 129.5 56 L 139 58.5 L 133.5 61 L 128.5 60 L 125.5 62 L 125.5 61 L 127 60.5 L 126.5 58 L 121 57 Q 119.7 53.7 124.5 55 L 127 53.5 L 121 53 L 121 51 Q 118 52 119 49 L 116 49 L 116 47.5 L 114 42 L 110.5 42 L 107 44 L 106 41.5 L 108 41.5 L 107 39.5 L 108.5 40 L 112.5 38 Z "
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 41 L 264 47.5 L 263 47.5 L 262.5 41 Z "
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 42 L 205.5 43 L 207 42.5 L 207 44.5 L 205.5 48 L 204 47.5 L 206 47 Q 207.1 44.3 204.5 45 L 203 45.5 L 204 43.5 L 203.5 42 Z "
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 44 L 262 46.5 L 260 45.5 L 260.5 44 Z "
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105 45 L 108.5 46 L 110 45.5 L 109 46.5 L 110.5 49 L 108.5 49 L 103 48.5 L 105 45 Z "
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 45 L 149 46.5 Q 148.2 49.1 151.5 48 L 153.5 49 L 158.5 46 L 161 49.5 L 148.5 50 L 144.5 49 L 142 46.5 L 143.5 47 L 149.5 45 Z "
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184 45 L 187 45 Q 185.5 48.8 188.5 48 L 188.5 49 L 183 48.5 L 184 45 Z "
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 46 L 223 49 L 219 48.5 L 222 48 L 222.5 46 Z "
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 47 L 210.5 47 L 216 48.5 L 212.5 49 L 210.5 49 L 207 48.5 L 208.5 47 Z "
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 47 L 232 47.5 Q 231.3 49.8 227.5 49 L 227.5 48 L 229.5 47 Z "
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 47 L 241 48.5 L 237.5 49 L 238.5 47 Z "
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 48 L 101 48.5 L 97.5 49 L 97.5 48 Z "
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111 55 L 115 55 Q 114 58 117 57 L 117 64 L 112.5 65 L 112.5 63 L 111 62.5 L 111 55 Z "
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16 56 L 24 56 L 24 72 L 16 72 L 16 56 Z "
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 56 L 96 56 L 96 63 L 88 63 L 88 56 Z "
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 57 L 122 58.5 L 120 59.5 L 123 61.5 L 121 62.5 L 121.5 61 Q 118.9 60.3 120 63 L 118 63 L 119.5 57 Z "
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79 63 L 87 63.5 L 86 65.5 L 86.5 67 L 79 68 L 79 63 Z "
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 63 L 109 63.5 L 106 65 Q 107.1 67.7 104.5 67 L 100 69 Q 101.5 73.5 97 72 L 96.5 69 L 96 72 L 93.5 73 L 92.5 71 L 90.5 75 L 91 73.5 Q 91.7 70.5 88 72 L 89 75.5 L 88 78.5 L 88 80 L 83 80 L 84 75.5 L 81 69.5 L 82.5 69 L 86.5 72 L 87 69 Q 90 70 89 67 L 93 67 Q 91.3 72.2 95 71 Q 92.9 65.8 97.5 67 L 99.5 66 L 101 66.5 L 102 64.5 L 100.5 63 Z "
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 63 L 177 63.5 L 177 65.5 L 175.5 68 L 176 66.5 L 175.5 65 L 173 65.5 L 172.5 67 L 170.5 63 Z "
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 63 Q 195 65 191.5 67 Q 187.8 67.8 187 65.5 Q 186.2 62.9 189.5 64 L 190.5 63 Z "
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 64 L 170 65.5 L 168.5 65 L 167.5 64 Z "
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 68 L 181.5 70 L 182.5 68 Z "
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184 68 L 192.5 68 L 193 70.5 L 192 70.5 Q 192.8 68.3 190.5 69 L 189 71.5 Q 191.3 72.8 188.5 74 Q 187.3 71 183 72 L 184 68 Z "
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194 72 L 196 72.5 L 196 80 L 194 79.5 L 194 72 Z "
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 72 L 200 79.5 L 199 79.5 L 199.5 72 Z "
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 74 L 143.5 75 Q 145 72.5 150.5 74 L 155 76.5 L 154.5 78 L 146.5 78 L 144.5 77 L 143.5 78 L 135.5 78 L 132 76 Q 133.1 79.3 129 78 L 128 75.5 L 132.5 74 Z M 150 76 L 150 77 L 152 77 L 150 76 Z "
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 76 L 124 79 Q 127 80.3 126 76.5 L 127 76.5 L 128 80 L 119 81 L 118.5 79 L 117 79.5 L 123.5 76 Z "
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 79 L 165.5 80 Q 167.3 77.3 169 81.5 L 168.5 84 L 165.5 84 L 160 80.5 L 163.5 79 Z "
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 80 L 111.5 82 L 112.5 80 L 113 81.5 Q 111.5 84.5 110 81.5 L 110.5 80 Z "
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 83 L 81 85.5 Q 82 89.3 79 88 Q 76.9 82.8 81.5 84 L 82.5 83 Z "
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 85 Q 181.2 86.8 180.5 94 L 183.5 92 L 185 95.5 L 185.5 97 L 191 94.5 L 189 93.5 L 188.5 95 L 188 92 Q 191 93 190 90 L 193 90 L 193 96 L 190.5 96 L 186 97.5 L 191.5 100 L 196 99 L 195 95.5 L 199.5 95 L 201 96.5 L 199.5 100 L 194.5 102 L 192.5 102 Q 188 102.5 187.5 99 L 187 101 Q 184.3 102.1 185 99.5 L 185.5 98 L 183.5 99 L 183 97 L 177.5 99 L 176 96.5 Q 179.2 94.5 179 90 Q 175.3 88.8 177 94 L 174.5 94 L 171 87.5 L 173 86.5 L 172.5 88 Q 174.8 88.8 174 86.5 L 175 86.5 L 175.5 88 L 176.5 85 Z "
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 86 L 107.5 88 L 109 87.5 L 108 91.5 L 109.5 91 Q 112.8 89.9 112 92.5 L 113 95.5 L 110.5 97 L 108 96 L 107.5 92 L 101 94.5 L 102 96.5 L 97 97 L 96.5 101 L 95.5 99 L 93 99.5 L 92 101.5 L 93 103.5 L 89 111 L 86 109.5 L 88.5 104 Q 92.3 105.3 91 101.5 L 90.5 100 L 92 100.5 L 91 98.5 L 94 97.5 L 93.5 96 L 96 95.5 L 96 93.5 L 97.5 91 L 101.5 88 L 104 88 L 104.5 86 Z "
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16 88 L 24 88 L 24 96 L 16 96 L 16 88 Z "
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64 95 Q 66.7 93.9 66 96.5 L 67 96.5 Q 66.3 94.3 68.5 95 L 67 97.5 L 68.5 99 Q 72.3 100.3 71 96.5 L 70.5 95 L 75 97.5 L 73.5 98 L 72 97.5 L 74 100.5 L 70.5 106 L 70 104 L 67 102.5 L 66.5 98 L 66 101 Q 63 102.3 64 98.5 L 64 96.5 L 64 95 Z "
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127 95 L 136.5 95 L 137 96.5 L 134.5 99 L 127 99 L 127 95 Z "
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227 95 L 237 95.5 L 233 96 Q 232 99.8 234.5 101 Q 236.8 100.3 236 102.5 L 237 102.5 L 240.5 95 L 243.5 96 L 244.5 95 L 252.5 95 L 252.5 96 L 248.5 97 L 247 96.5 Q 246.3 98.8 248.5 98 L 249.5 99 L 251.5 97 L 254 97.5 Q 253.3 99.8 255.5 99 L 255 97.5 L 255 95 L 260.5 95 L 261.5 97 L 256 99.5 L 261 100.5 L 255.5 101 L 253.5 100 L 250.5 103 L 249.5 102 Q 246.9 101.3 248 104 L 245.5 104 L 242.5 105 L 242.5 104 L 245 103.5 L 245 101.5 L 243.5 98 L 240 99 L 241 105.5 L 239.5 109 L 237 108 L 236.5 105 L 235 110.5 L 236 113.5 L 236.5 115 L 237.5 113 L 238 114.5 Q 237.5 117.5 233.5 117 L 233.5 116 L 235 115.5 L 231 111.5 L 232 110.5 L 231 106.5 Q 233.3 105.2 232 100.5 L 227 98.5 L 229 97.5 L 227 97 L 227 95 Z M 251 99 L 250 101 L 252 100 L 251 99 Z "
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 267.5 95 L 283.5 95 L 284 97.5 L 285 97.5 Q 284.2 94.5 288 96 Q 289.3 99 285.5 98 L 283 99 L 285.5 103 L 288.5 102 L 289 106 L 287 106 Q 288.1 103.3 285.5 104 L 283 105 L 282.5 103 Q 281.3 105.3 280 102.5 Q 281.1 99.2 278.5 100 L 278.5 102 L 273 99.5 L 272.5 97 L 269 98 Q 270 95 267 96 L 266.5 98 L 265.5 96 L 267.5 95 Z M 277 96 L 277 97 L 282 98 Q 283 94 277 96 Z M 276 97 L 275 99 L 275 100 L 278 100 L 276 99 L 276 97 Z "
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 96 L 218.5 97 L 220.5 96 L 219.5 98 L 215.5 100 L 211.5 99 L 211.5 101 L 208 102 L 206.5 105 L 205 105.5 L 205.5 107 L 204 104 Q 206.7 105.1 206 102.5 L 205.5 101 Q 208.1 101.7 207 99 L 210.5 99 L 214.5 96 Z "
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128 100 Q 136.9 98.4 141 102.5 Q 139.4 105.4 134 104.5 L 136 105.5 L 132.5 107 L 131 106.5 L 132 111 Q 129.3 109.9 130 112.5 L 128.5 112 L 121 111.5 L 129.5 111 L 131 109.5 L 128 108.5 L 130 107.5 L 128 103.5 L 128 100 Z M 131 104 L 131 105 L 133 105 L 131 104 Z "
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175 103 L 181 103 L 181 105.5 Q 184.5 107.2 183 113 L 177 113 L 177 115.5 L 174.5 119 L 177 120.5 L 175.5 144 L 174.5 142 L 174 144 L 171 145.5 L 171 149 Q 175.1 147.3 174 151.5 L 179 162.5 L 176 164 L 175.5 160 L 174 160.5 L 173.5 159 L 170.5 160 L 169 159.5 Q 169.6 162.3 163.5 161 L 165 158.5 Q 163.8 154.8 167.5 156 L 169 156.5 Q 169.9 153.5 165.5 155 L 163.5 153 L 159.5 157 L 157 156.5 L 160 156 L 160 152 Q 162.7 153.1 162 150.5 L 164.5 146 L 165 148.5 L 163 151.5 L 167.5 152 L 166.5 150 L 165 150.5 L 166.5 148 L 167 150 Q 169.7 151.1 169 148.5 L 167.5 146 L 166 146.5 L 165.5 142 L 164.5 144 L 164 140.5 L 165 136.5 L 164 133.5 L 165 131.5 L 163 127.5 L 164 124.5 L 162 124.5 Q 163.8 121.3 165.5 125 Q 168.5 125.9 167 121.5 L 167.5 120 L 164.5 121 L 159 119.5 L 159.5 118 L 156 115.5 L 155 111.5 L 159 111 L 159.5 113 L 160 111 L 165.5 111 L 166 112.5 L 167.5 112 L 170.5 111 L 172.5 114 L 173 111 L 175 110.5 L 175 103 Z M 157 113 Q 155 117 159 116 L 159 114 L 157 113 Z M 168 114 L 167 116 L 164 117 L 166 117 L 167 119 L 167 117 L 169 117 L 168 114 Z M 166 126 L 164 128 L 165 130 L 168 128 L 166 126 Z M 167 130 Q 164 135 168 134 L 167 130 Z M 170 132 L 169 140 L 170 140 L 170 132 Z M 170 151 L 169 155 L 172 155 L 170 154 L 170 151 Z "
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16 104 L 24 104 L 24 112 L 16 112 L 16 104 Z "
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 104 L 144.5 106 Q 143.3 103.8 142 106.5 L 147 109.5 L 142.5 110 L 139.5 109 L 134.5 110 L 133.5 108 L 136.5 109 L 138 106 L 143.5 104 Z "
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 105 L 152 106 L 151.5 108 L 149.5 107 L 148 107.5 L 149.5 105 Z "
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 106 L 243 108 L 241 107.5 L 242.5 106 Z "
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 107 Q 62.9 111.6 65.5 113 L 67 113.5 L 66 115.5 L 66.5 117 L 65 116.5 Q 64.3 118.8 66.5 118 L 66.5 119 L 63 116.5 L 63.5 107 Z "
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 107 Q 97.8 107.8 97 111.5 L 93 113 L 93 108 L 94.5 108 L 95.5 107 Z "
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 110 L 154 111.5 L 151.5 112 L 148.5 111 L 148.5 110 Z "
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 111 L 90 112.5 L 87 113 L 86.5 115 L 85.5 113 L 85 115.5 Q 87.3 116.8 84.5 118 L 84 112.5 L 85.5 111 Z "
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111 111 L 115 111 L 115 112.5 L 116 112.5 Q 115.2 109.9 118.5 111 L 120 112.5 L 121 118.5 L 117.5 120 Q 117 116.5 112.5 117 L 111 117.5 Q 110.2 114.9 113.5 116 L 113.5 115 Q 108.9 116.2 111 111 Z "
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 292 111 L 296 111.5 L 294 112.5 L 296 113 L 295 115.5 L 295.5 117 Q 291.3 115.7 292 111 Z "
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302 111 L 305 111.5 L 305 127.5 L 304 127.5 Q 304.8 123.3 302 122.5 L 302 111 Z "
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 113 L 190 165.5 L 189 165.5 L 189.5 113 Z "
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 113 L 221.5 115 L 221.5 116 L 220 116.5 L 220.5 118 Q 218.3 117.3 219 119.5 L 220 122.5 L 218.5 124 L 209.5 124 L 207 126.5 L 209 128.5 L 209 145 L 207 145.5 L 207 158.5 L 209 166.5 L 205 168 L 205 161.5 L 206 160.5 L 206 143.5 Q 203.5 142 205 136.5 L 206 134.5 Q 203.8 133.3 206.5 132 Q 209.1 132.8 208 129.5 L 206.5 130 L 205 129.5 L 207 128.5 L 206 126.5 L 209 119 L 211.5 120 L 213.5 120 Q 215.8 120.8 215 118.5 L 214.5 117 L 217 116.5 L 216.5 115 L 219 114.5 L 218.5 113 Z "
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 113 L 298 116 Q 301 117.3 300 113.5 L 301 113.5 L 300 127.5 Q 302.2 128.8 301 133.5 L 303 135.5 L 303 141 Q 299.3 139.8 301 145 L 295.5 145 L 296 143.5 L 299 139.5 L 299 136.5 L 298 134 Q 295 135.3 296 131.5 L 295 129.5 L 296 126.5 L 295 123.5 L 296 119.5 L 295.5 118 L 297 118 L 297.5 113 Z "
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 114 L 122.5 116 L 123.5 114 Z "
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 271.5 116 L 272 120 Q 277.7 119 280 122.5 L 278.5 123 Q 277.3 120.7 276 123.5 L 279 126.5 L 278 127.5 Q 278.8 130.1 275.5 129 L 274 126 L 271 125.5 L 271.5 116 Z M 272 123 Q 271 126 274 125 Q 275 122 272 123 Z "
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 117 L 225 118.5 L 226 120.5 L 224.5 125 L 224 118.5 L 225.5 117 Z "
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 118 L 257 124 Q 253.2 122.5 254 125.5 L 251.5 130 Q 247.8 130.8 247 128.5 L 250 120 L 254.5 119 L 256 119.5 L 256.5 118 Z "
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 120 L 112 123 L 114.5 124 L 116.5 121 Q 118.8 120.3 118 122.5 L 116 122.5 L 117 125.5 Q 114.3 127.8 115 133.5 L 115.5 135 Q 113.3 135.8 114 133.5 L 113 133.5 L 112 135.5 L 116 141.5 L 115 144.5 L 115.5 146 L 113.5 145 L 111 146 L 112 143.5 L 111 142.5 L 111 134.5 L 112 131.5 L 111 126 Q 113.7 127.1 113 124.5 L 111 124.5 L 111.5 120 Z M 113 139 L 112 142 L 113 142 L 113 139 Z "
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 120 L 232 120 L 232 126.5 L 232 128.5 L 232 146.5 L 231 152 L 227 152 L 227 144 L 229 143.5 L 229 133.5 L 227.5 128 L 226 129.5 L 224.5 143 L 223.5 128 L 221 129 L 221 125 L 222.5 125 L 224 128 L 226 127.5 L 226 125.5 Q 225.3 121.8 227.5 121 L 229.5 120 Z "
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64 121 L 66 121.5 L 64 122.5 L 64 121 Z "
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 125 Q 82.5 124.1 81 128.5 L 78.5 138 L 78 133.5 L 79 128.5 L 78.5 127 L 80 127.5 L 79.5 125 Z "
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257.5 127 L 271.5 127 L 272 129 L 256 128.5 L 257.5 127 Z "
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16 128 L 24 128 L 24 144 L 16 144 L 16 128 Z "
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48 128 L 56 128 L 56 144 L 48 144 L 48 128 Z "
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 128 L 65 130.5 L 64 130.5 L 64.5 128 Z "
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 128 L 96 128 L 96 144 L 88 144 L 88 128 Z "
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 133 L 65 135.5 L 64 135.5 L 64.5 133 Z "
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 138 L 65 141.5 L 64 141.5 L 64.5 138 Z "
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 142 L 254 143.5 L 246.5 144 L 247.5 142 Z "
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257.5 142 L 271.5 143 L 274.5 142 L 281 143.5 L 279 144 Q 280.5 149.4 277.5 151 Q 272.3 152.3 271 149.5 L 271 144 L 256.5 144 L 257.5 142 Z "
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 284.5 142 Q 289.3 140.3 288 144.5 L 289 149 L 283 149 L 283 145.5 L 284.5 142 Z "
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 145 L 87.5 145 L 88 147 L 79 146.5 L 80.5 145 Z "
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 147 L 251 148.5 L 247 149 L 247.5 147 Z "
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 148 L 80.5 149 L 88 149 Q 89.1 152.5 81.5 151 L 79.5 148 Z "
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 148 L 113 150.5 L 112 153.5 L 115.5 155 L 119.5 153 L 120.5 155 L 118.5 154 L 117 156.5 L 118 159.5 L 117.5 161 L 111 161 L 111.5 148 Z "
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 149 L 65 152.5 L 64 154.5 L 65 157 Q 67.7 155.9 67 158.5 L 63.5 161 L 63.5 149 Z "
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 149 L 116.5 151 L 117.5 149 Z "
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 150 Q 253.8 149.3 253 151.5 L 252 156 L 254 156.5 L 251 157 L 251 154 Q 248.3 155.1 249 152.5 L 251.5 150 Z "
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224 151 Q 227 149.8 226 153.5 L 227 158.5 L 226.5 160 Q 230.9 161.5 230 158.5 L 231.5 153 L 232 160 L 234 159.5 L 233 155.5 L 234 155.5 L 234.5 158 L 236 157.5 L 232.5 162 L 231 161.5 L 231 164 L 223 164 L 224 159.5 L 223 155.5 L 224 151 Z "
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16 152 L 24 152 L 24 168 L 16 168 L 16 152 Z "
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 152 L 85.5 154 L 87 153.5 Q 85.8 156.3 84.5 154 L 82.5 155 L 81.5 153 Q 83 155.5 84.5 152 Z "
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 152 L 96 152 L 96 159.5 L 97 163.5 Q 95 167 93 162.5 L 93 159 L 88 159 L 88 152 Z "
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 273.5 155 Q 278.8 153.3 277 158.5 Q 278.3 161.3 279.5 159 L 281 159.5 L 279.5 162 L 275.5 161 L 273.5 162 L 270.5 160 Q 268.2 163.2 261.5 162 L 259 160.5 L 265.5 159 L 268.5 160 L 270.5 159 L 272 159.5 Q 271.3 155.8 273.5 155 Z "
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 156 L 123 157.5 L 120 158 L 120.5 156 Z "
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 156 L 257 161 Q 254.3 162.1 255 159.5 L 252.5 159 L 251 158.5 L 252.5 158 L 256 158.5 L 256.5 156 Z "
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 158 L 86.5 161 L 88 160.5 L 95.5 175 Q 98.1 174.2 97 177.5 Q 98.8 175.9 100.5 179 Q 107.5 177.5 107 180.5 L 108 183.5 L 105.5 185 L 103.5 184 L 103.5 186 Q 101.5 182.8 97 183 L 97 180 Q 94.3 181.1 95 178.5 L 94 176 L 90 174.5 L 84 162.5 L 86 162.5 Q 86.8 159.9 83.5 161 L 84 159.5 L 84.5 158 Z "
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 158 L 156.5 161 Q 153.5 160.2 155 164 L 151.5 164 L 150 163.5 L 151.5 166 L 153.5 165 L 155.5 165 Q 159.3 165.8 160 163.5 L 160.5 162 L 161 168.5 L 158.5 175 Q 154.5 175.5 154 172.5 Q 155.1 169.2 152.5 170 L 153 171.5 L 152 173.5 L 153 176 L 148 175.5 Q 151.5 174 149 172.5 L 148.5 171 L 143 171 L 142.5 169 L 129.5 169 L 127 170 Q 125.7 166.3 131.5 168 L 134.5 167 L 137 165.5 L 135.5 163 L 139 164 Q 138 167 141 166 Q 139.9 163.3 142.5 164 L 144 163.5 L 144.5 165 L 150.5 162 L 152 162.5 L 153.5 159 L 156.5 158 Z M 145 166 L 144 168 L 148 168 L 145 166 Z "
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158 158 L 161 159.5 Q 161.8 161.8 159.5 161 L 158 158 Z "
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 159 L 128 160 Q 126.8 163 130.5 162 L 134 164.5 L 129.5 167 L 127 166.5 Q 125.9 163.2 128.5 164 L 128.5 163 Q 125.9 163.7 127 161 L 123.5 161 L 123.5 160 L 125.5 159 Z "
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 159 L 185 164.5 L 181 167 L 180 175.5 L 181 175.5 Q 180 169 184.5 168 L 186 172.5 L 185 172.5 L 184.5 171 L 184 176 L 182 176.5 L 183 179 L 178 177.5 L 178.5 176 L 175 176 L 175 167 Q 180.2 169.1 179 164.5 L 180 160 L 184.5 159 Z "
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 159 L 188 170.5 L 190 175 L 187 173.5 L 186 160.5 L 187.5 159 Z "
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 296.5 159 L 300 159 L 300 168.5 L 299 171 L 294 171 L 294 168.5 L 295 166.5 L 294 161.5 L 296.5 159 Z "
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 162 L 64.5 165 L 68.5 162 L 69 164.5 L 67 167.5 L 70 168 L 73 175.5 L 70.5 181 L 68 181.5 L 72 182 Q 70.9 184.7 73.5 184 L 75 183.5 L 75.5 185 L 80 184 L 82 187.5 L 81.5 189 L 83 189.5 L 80 190.5 L 83.5 195 L 84 193 L 88 194 L 89 197.5 L 88.5 199 L 97 201 L 95.5 204 L 95 202 Q 87.5 203 84 200 L 83.5 198 L 80 199 L 79.5 192 L 77.5 193 L 78 191.5 L 76 188.5 L 74.5 185 Q 73.1 188 68 187.5 L 69 193 L 63 193 L 63 187 L 68 186.5 L 64 186 L 64 181 L 67.5 181 L 67.5 180 L 63 179 Q 61.9 176.3 64.5 177 L 64 175.5 L 63.5 162 Z M 69 171 L 66 174 Q 65 178 70 176 L 70 171 L 69 171 Z "
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 265.5 164 L 269 164.5 L 265.5 165 L 265.5 164 Z "
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235 166 L 237 166.5 L 236.5 168 Q 240.9 166.5 240 169.5 L 241 172 L 239 172.5 L 240 176 Q 234.4 177.9 236 173 L 238 172.5 L 233 170.5 L 233 168 Q 236 169 235 166 Z "
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224 169 L 227 170.5 L 224 171 L 224 169 Z "
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 171 L 290.5 171 L 293 171 Q 292 174 295 173 L 295 177 L 281 176.5 L 285.5 174 L 285.5 176 Q 289.3 177.3 288 173.5 L 288.5 171 Z "
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 172 L 206.5 174 Q 210.7 172.9 209 177 L 201 176.5 L 203.5 175 L 205 175.5 L 204 173.5 L 206.5 172 Z "
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223 172 L 230 172 L 230 174.5 L 231 177 L 223 177 L 223 172 Z "
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 173 L 142.5 173 L 143 174.5 L 144 177 L 127.5 177 L 127 174 L 132.5 173 Z "
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 174 L 195 176.5 L 193 177 L 193 184 L 190 184 L 189.5 181 L 188 181.5 L 188 179 Q 190.7 180.1 190 177.5 L 192 177.5 L 191.5 174 Z "
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246 174 Q 250.1 172.7 249 176 Q 244.9 177.3 246 174 Z "
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 175 Q 114.8 173.3 113 178.5 L 112 178.5 Q 113.3 174.8 109.5 176 L 109.5 175 Z "
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 277.5 175 L 280 175.5 L 277.5 176 L 277.5 175 Z "
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 182 L 178.5 184 L 180.5 183 L 180.5 184 L 178 185.5 L 177.5 187 Q 176 184.5 174.5 188 Q 172.3 188.8 173 186.5 L 175 186.5 Q 174.3 184.3 176.5 185 L 176.5 184 Q 173.7 184.7 175.5 182 Z "
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16 184 L 24 184 L 24 192 L 16 192 L 16 184 Z "
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 186 L 107 188.5 L 106 188.5 L 106.5 186 Z "
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 191 L 125 191.5 L 123 192 L 123 194 Q 126.7 192.5 126 195.5 L 124.5 195 L 123 195.5 L 123.5 197 L 115 192.5 L 116.5 191 Z "
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128 191 L 142.5 191 L 144 192.5 L 142.5 194 L 128 194 L 128 191 Z "
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 191 L 160 191.5 L 155.5 193 L 154.5 191 Z "
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 191 Q 168.3 189.3 167 193 L 165 193 Q 166.1 195.7 163.5 195 L 161 194 L 159.5 197 L 153.5 198 L 151.5 198 L 137.5 201 L 136.5 200 L 128 200 L 127 197.5 L 128.5 198 Q 138.8 199.2 144 197 Q 142.7 193.3 148.5 195 L 153.5 194 L 155.5 194 L 158.5 193 L 160.5 194 L 163 192.5 L 162.5 191 Z "
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190 196 L 192 196.5 L 188 202.5 Q 186.8 207.1 192 205 L 192 208 L 185.5 208 L 185 206 L 188 205.5 L 184 205 L 183 202.5 L 184 200 L 188.5 197 L 190 197.5 L 190 196 Z "
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 204 L 100 204.5 Q 99.3 206.8 101.5 206 L 103 205.5 L 102.5 207 L 104.5 206 L 107.5 208 L 109.5 208 L 112.5 209 Q 114 206.5 115.5 210 L 117 210 L 117 213 Q 119.7 211.9 119 214.5 L 122.5 216 L 122.5 214 Q 127.3 212.8 128.5 215 L 129 213 L 133.5 214 L 135.5 213 Q 137.3 215.8 143.5 214 L 146 212.5 L 147.5 215 L 148.5 212 L 155.5 214 L 155.5 213 L 153 212.5 Q 154.3 209.8 155.5 212 L 158.5 213 L 159.5 211 L 161 215 L 151.5 215 L 150.5 216 L 148.5 215 L 145 215.5 L 144.5 214 L 144 218 L 129.5 218 L 126 220.5 L 128 221 L 128 225 L 120.5 225 L 121 223.5 Q 119.7 219.3 124.5 221 L 124.5 220 Q 119.1 220.6 117 219 Q 118.8 214.1 112.5 216 Q 109.5 214.4 111 209 L 99 208.5 L 102 207.5 L 98.5 206 L 96 206.5 L 95.5 208 L 83.5 208 L 79 209 Q 76.8 203.4 82.5 205 L 83.5 206 L 95.5 206 L 97.5 204 Z M 153 222 L 145 224 L 160 224 L 160 222 L 153 222 Z "
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16 208 L 24 208 L 24 216 L 16 216 L 16 208 Z "
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 208 L 181 208.5 L 172.5 209 L 172.5 208 Z "
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 210 L 164 211 L 163.5 213 L 161.5 210 Z "
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 218 L 151.5 219 L 153.5 218 L 160 219 L 161 224 L 168 224.5 L 129 225 L 129 222 L 143.5 222 L 144 219.5 L 145.5 218 Z "
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16.5 224 L 24 224.5 L 16.5 225 L 16.5 224 Z "
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 224 L 56 224.5 L 48.5 225 L 48.5 224 Z "
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 224 L 72 224.5 L 64.5 225 L 64.5 224 Z "
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 224 L 96 224.5 L 88.5 225 L 88.5 224 Z "
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 224 L 200 224.5 L 184.5 225 L 184.5 224 Z "
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 224 L 216 224.5 L 208.5 225 L 208.5 224 Z "
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 224 L 240 224.5 L 232.5 225 L 232.5 224 Z "
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 224 L 264 224.5 L 256.5 225 L 256.5 224 Z "
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280.5 224 L 288 224.5 L 280.5 225 L 280.5 224 Z "
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 304.5 224 L 312 224.5 L 304.5 225 L 304.5 224 Z "
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,42,100)",
    stroke: "rgb(10,42,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 328.5 224 L 336 224.5 L 328.5 225 L 328.5 224 Z "
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 0 L 102.5 0 L 105 5 L 110.5 5 L 110.5 6 Q 103.8 4.3 102 7.5 L 101.5 16 L 101 9 Q 98 10 99 7 L 95.5 7 L 94.5 8 L 88 8 L 88 16 L 95 16 L 95 20 L 99 20 L 99 21.5 L 97.5 21 Q 94.5 20.5 96 27.5 L 95 30.5 L 95 32.5 L 95 43.5 L 96.5 45 L 97 43.5 L 97 41.5 L 97.5 40 L 98 46 Q 95.3 44.9 96 47.5 Q 96.8 49.8 100.5 49 L 102.5 48 Q 103.8 50.2 108.5 49 L 110.5 49 Q 114.3 47.8 113 51.5 L 114 51.5 Q 113.3 49.3 115.5 50 L 115 48.5 L 115.5 47 L 116 49 L 119 49 L 121 53 L 126.5 53 L 126.5 54 L 121 55 Q 122 58 119 57 L 119 60.5 L 117.5 63 L 117 57 Q 114 58 115 55 L 111 55 L 111 62.5 L 112.5 63 L 116 64.5 L 112.5 66 L 109.5 64 L 109.5 66 L 107.5 66 L 105.5 65 L 104 65.5 Q 105.3 62.8 106.5 65 L 109 63.5 L 96 63 L 96 56 L 88 56 L 88 64 L 94.5 64 L 94.5 65 L 87.5 65 L 86.5 63 L 79 63 Q 76.3 70.5 84.5 68 Q 87.6 64.4 95 66 L 95 71 L 93.5 71 L 92 71.5 L 93 67 L 89 67 Q 90 70 87 69 L 87 71.5 L 84.5 70 L 81.5 69 Q 78.8 70.3 80 75.5 L 81 78.5 Q 79.5 82.3 74 81 Q 72.3 88.6 75.5 92 L 77.5 88 L 78.5 91 L 80 90.5 L 76 92.5 L 77 94.5 L 76 94.5 L 74.5 92 L 73 92.5 L 74 90.5 L 72 89.5 Q 69.9 95.3 74.5 94 L 74.5 95 L 72.5 96 L 67 95 L 66.5 97 L 66 95 Q 63.3 93.9 64 96.5 L 64 98.5 Q 63 102.3 66 101 L 66.5 98 L 68.5 105 L 70 104.5 L 71 106.5 L 69.5 106 Q 65.1 104.5 66 107.5 L 65 107.5 L 67 104.5 L 66 102 Q 63 100.8 64 104.5 L 63 105.5 L 63 116.5 L 65 117.5 L 64 114.5 L 65 114.5 L 65.5 116 L 67.5 109 L 68 113.5 L 67 115.5 L 67.5 117 L 66 116.5 L 65 119.5 L 67 119.5 L 66.5 122 L 64 121 L 65 123.5 L 64 126.5 L 65.5 129 L 64 128.5 L 65 132.5 L 64 133.5 L 64 142.5 Q 67.5 144 65 145.5 L 66 149.5 L 65 151.5 L 65 153.5 L 64.5 155 L 64 153.5 L 64 151.5 L 63.5 149 L 63 171.5 L 65 176.5 L 63 177 Q 61.8 180 65.5 179 L 70.5 181 Q 71.8 178.8 73 181.5 L 74 183.5 L 72 184 Q 73.3 180.7 68.5 182 L 64 181 L 64 186 L 67.5 186 L 71 188.5 L 70 192 L 78.5 193 L 80 192.5 L 80 204 L 89.5 204 L 94.5 205 L 96 204.5 L 95.5 206 L 83.5 206 L 79 205 Q 76.8 210.6 82.5 209 L 83.5 208 L 99 207.5 L 97.5 205 Q 101.2 207 99.5 209 L 111 209 L 111 214.5 Q 112.4 217.3 117 216 Q 115.5 219.8 118.5 219 L 125 220.5 L 121 221 L 119.5 225 L 96.5 225 Q 94.8 222.3 88.5 224 L 87.5 225 L 72.5 225 Q 70.8 222.3 64.5 224 Q 62.7 226.8 56.5 225 Q 54.8 222.3 48.5 224 L 47.5 225 L 24.5 225 Q 22.8 222.3 16.5 224 L 15.5 225 L 0 225 L 0 0 Z M 16 8 L 16 16 L 24 16 L 24 8 L 16 8 Z M 16 32 L 16 48 L 24 48 L 24 32 L 16 32 Z M 16 56 L 16 72 L 24 72 L 24 56 L 16 56 Z M 16 88 L 16 96 L 24 96 L 24 88 L 16 88 Z M 16 104 L 16 112 L 24 112 L 24 104 L 16 104 Z M 16 128 L 16 144 L 24 144 L 24 128 L 16 128 Z M 48 128 L 48 144 L 56 144 L 56 128 L 48 128 Z M 88 128 L 88 144 L 96 144 L 96 128 L 88 128 Z M 16 152 L 16 168 L 24 168 L 24 152 L 16 152 Z M 81 152 L 83 155 L 85 154 Q 86 156 87 154 L 87 152 L 81 152 Z M 16 184 L 16 192 L 24 192 L 24 184 L 16 184 Z M 63 187 L 63 193 L 69 193 L 69 189 Q 68 186 63 187 Z M 16 208 L 16 216 L 24 216 L 24 208 L 16 208 Z M 114 220 L 113 223 L 116 223 L 114 222 L 114 220 Z "
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 0 L 117.5 0 L 123.5 3 Q 125 -0.5 126.5 2 L 142.5 3 L 144 2.5 Q 143 5 138.5 4 L 137.5 3 L 129.5 3 L 127.5 8 L 126.5 3 L 125 6.5 L 125.5 8 Q 123.3 8.8 124 6.5 L 121.5 4 L 114.5 2 L 113.5 0 Z "
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 0 L 167.5 2 L 177.5 2 Q 179 -0.5 180.5 3 L 186.5 0 L 191.5 0 L 193.5 2 L 208 4 L 209 7.5 L 207 8 Q 208.1 5.3 205.5 6 L 203.5 5 L 197 6 Q 198.8 1.1 192.5 3 Q 191 -0.5 189.5 2 L 182.5 4 L 180 6.5 Q 180.5 12 177.5 14 L 176 5.5 L 174.5 4 L 161 3 L 160.5 0 Z M 178 3 L 178 9 L 179 7 L 178 3 Z "
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208 0 Q 211.4 -0.8 212.5 2 L 215 0.5 L 215 3 L 209.5 3 L 208 0 Z "
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 0 L 222 2.5 L 221 2.5 L 221.5 0 Z "
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 0 L 225 3 L 223 2.5 L 224.5 0 Z "
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227 0 L 231 0.5 L 229 1.5 L 231 2.5 L 227 3 L 227 0 Z "
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 0 L 265.5 0 L 267 1.5 L 267.5 3 L 273 3 L 273.5 0 L 355 0 L 355 224.5 L 354.5 225 L 336.5 225 Q 334.7 222.3 328.5 224 L 327.5 225 L 312.5 225 Q 310.8 222.3 304.5 224 L 303.5 225 L 288.5 225 Q 286.7 222.3 280.5 224 L 279.5 225 L 264.5 225 Q 262.8 222.3 256.5 224 L 255.5 225 L 240.5 225 Q 238.7 222.3 232.5 224 L 231.5 225 L 216.5 225 Q 214.7 222.3 208.5 224 Q 206.8 226.8 200.5 225 L 199.5 224 L 184.5 224 L 183.5 225 L 168.5 225 L 167.5 224 L 161 224 L 159 218.5 L 161 213.5 L 160 212.5 L 163.5 209 L 165.5 209 L 167.5 210 L 168 208 L 172.5 207 L 172.5 209 L 181.5 209 L 183.5 207 L 184.5 208 L 192 208 Q 193.8 203.5 188.5 205 L 184.5 206 L 184.5 205 L 192 204 L 192 201 Q 189 202.3 190 198.5 L 189.5 197 Q 190.8 199.2 192 196.5 L 191 194.5 L 193 194.5 L 193 192 Q 195.7 193.1 195 190.5 L 196 190.5 L 196.5 192 L 197 189 L 192 186.5 L 194.5 186 L 197.5 187 L 197.5 186 L 193 185 L 193 177.5 L 194.5 177 L 194.5 175 L 198.5 177 L 201.5 175 L 201.5 177 L 208.5 177 L 209 174.5 L 206 173.5 L 208 169.5 Q 205.5 168 209 166.5 L 207 158.5 L 207 145 L 209 144.5 L 209 128.5 Q 207 124.8 205 126.5 L 206.5 124 L 207.5 126 L 209.5 124 L 218.5 124 L 220 122.5 L 219 118 L 223 118.5 L 222 121 Q 225.3 119.7 224 124.5 L 225 124.5 L 226 120.5 L 225.5 119 Q 228.1 119.7 227 117 L 224.5 118 L 224.5 116 L 220 115 Q 218.7 111.7 223.5 113 L 223.5 115 Q 227.9 113.5 227 116.5 L 228.5 119 Q 225.9 118.2 227 121.5 L 225 126.5 L 225.5 128 L 224 128.5 L 224 142.5 L 225 142.5 L 225.5 136 L 226 142.5 L 223 145.5 L 224 146.5 Q 222.7 151.3 226 150 L 226.5 148 L 227 153.5 L 226 153.5 Q 227 149.8 224 151 L 223 158.5 L 223 160.5 L 223 164 L 231 164 L 231.5 161 L 233 172 L 238 172.5 L 236 173 Q 234.3 177.5 239.5 176 L 243 173.5 L 241 170.5 L 243 171.5 L 244 173.5 L 243.5 175 Q 245.8 175.8 245 173.5 L 247 172.5 L 246 176 L 250 176 L 250 174.5 L 253.5 175 L 257.5 177 L 273.5 177 L 276.5 175 L 281.5 177 L 295 177 L 295 173 Q 292 174 293 171 L 290.5 171 L 288 172.5 L 289 170 L 292 168.5 Q 291.3 163.8 293.5 162 L 294 164.5 L 293 167.5 L 294 167.5 L 294.5 166 L 295 167.5 L 294 171 L 299 171 L 299 169.5 L 300 168.5 L 300 159 L 293 159 L 293 156.5 L 293.5 155 Q 290.2 153.9 291 156.5 L 291.5 158 Q 288.9 158.8 290 155.5 L 287 154.5 L 285.5 152 L 283.5 153 L 280 152 L 280.5 154 L 282 153.5 L 280 157.5 Q 283.8 159.3 280.5 161 L 280.5 159 L 278.5 160 Q 276 158.8 277 155 Q 273.2 154 272 156.5 L 271.5 160 L 269.5 159 L 266.5 160 L 262.5 159 L 257 160 L 257 156 L 255.5 156 L 256 154.5 L 255.5 146 L 254 146.5 L 253 144.5 L 255.5 143 L 256.5 144 L 271 144 Q 269.5 149.4 272.5 151 Q 277.8 152.3 279 149.5 Q 277.8 143.4 280.5 144 L 282.5 143 Q 285.3 144.3 283 145.5 L 283 149 L 289 149 L 288 144.5 L 290 144 L 290.5 142 L 292.5 143 L 295 141.5 L 296 143.5 L 295.5 145 L 301 145 Q 299.8 139.7 303 140.5 L 303 135.5 L 301 133.5 L 300 120.5 Q 302.5 119 301 113.5 L 298.5 112 Q 295.9 113.4 296.5 118 L 295.5 116 L 294 116.5 Q 297 115.3 296 111 L 290.5 112 L 288.5 108 L 287 108.5 Q 290 106.5 289 100.5 L 284 97.5 L 283.5 95 L 267.5 95 L 267.5 96 Q 270.1 95.3 269 98 L 267 98 Q 268.1 95.3 265.5 96 L 260.5 98 L 260.5 97 L 262 96.5 Q 260.4 93.5 255 95 L 254.5 97 Q 252.5 93 244.5 95 L 242.5 96 L 240.5 95 L 236.5 103 L 236 100.5 L 237 95 L 227.5 95 L 227 97 L 230.5 96 L 230.5 97 L 222 98.5 L 222.5 100 Q 218.8 98 220.5 96 L 217.5 97 L 206.5 95 L 203.5 97 Q 200 93.8 193 95 L 194 85.5 L 193 83.5 L 194 81 Q 190.3 82.3 192 76.5 L 190 76.5 Q 189.3 74.3 191.5 75 L 191.5 73 L 193 73.5 L 193 68 L 184.5 68 L 182 69.5 L 183 67 L 187.5 66 L 191.5 67 Q 195 65 190.5 63 L 189.5 64 L 180.5 64 L 179 65.5 L 180.5 66 L 182 65.5 L 181.5 68 L 178.5 67 L 177 67.5 L 177.5 69 Q 175.8 65.9 174 67.5 L 178 65.5 L 176 64.5 L 176.5 63 L 170 63.5 L 170.5 65 L 167.5 64 L 165.5 65 Q 164.3 62 160 63 L 161 59 L 168 59 L 168 56 L 152 56.5 L 152.5 59 L 156.5 61 L 159 59.5 L 157.5 62 L 145 59.5 L 152 57.5 Q 149.8 56.3 152.5 55 L 160 54 L 159.5 52 L 152.5 52 L 149 50.5 L 161 49.5 L 160.5 48 Q 165.9 49.9 165 46.5 L 166 46.5 L 166.5 49 L 175.5 49 L 178 47.5 L 175 45.5 L 176.5 45 Q 178.5 51 188.5 49 L 193 47 L 193.5 49 L 202.5 49 L 202.5 48 L 201 47.5 L 204 45.5 L 200 44.5 L 204 42.5 L 200 41.5 L 203.5 40 L 208.5 46 L 204 43 L 204 45 Q 206.7 43.9 206 46.5 L 207 49 L 211.5 48 L 215.5 49 L 215.5 47 L 217.5 47 Q 220.1 46.3 219 49 L 223 49 L 224.5 46 L 224.5 48 L 227 48 Q 226 45 229 46 Q 230.1 48.7 227.5 48 L 227.5 49 Q 231.3 49.8 232 47.5 L 231.5 46 Q 232.6 48.8 236 48 L 236.5 46 L 237.5 49 L 241 49 Q 239.5 45.2 242.5 46 L 242 47.5 L 242.5 49 L 249.5 49 L 249.5 47 L 252 47 Q 251 50 254 49 Q 252.9 46.3 255.5 47 L 257 47.5 L 258 40.5 L 257 39.5 L 257 22.5 L 258 22.5 L 258.5 40 L 259 31 L 261 31.5 L 261 39.5 L 262 39.5 L 261.5 23 L 260 23.5 Q 259.3 20.9 262 22 L 262 18.5 L 260 18.5 Q 259.5 15.5 266.5 17 L 269.5 15 L 269.5 17 Q 275.6 18.8 273 11.5 L 272 11.5 L 270.5 14 L 267.5 10 L 266 10.5 L 265.5 9 L 264 9.5 L 264.5 8 L 260.5 8 Q 261.5 11.3 255.5 10 L 254 10.5 L 254.5 8 L 258.5 9 L 258.5 8 L 256 7.5 L 267.5 7 L 270.5 13 L 272 9.5 L 270 8.5 Q 272.7 7.4 272 4 L 258.5 3 Q 256.8 0.2 251.5 1 L 251.5 3 L 245.5 3 Q 246.3 -0.5 240 1 Q 241.4 5 234.5 3 L 234.5 2 L 239 1.5 Q 234.6 1.9 235.5 0 Z M 260 41 L 259 48 L 264 48 L 263 41 L 262 45 L 260 41 Z M 194 72 L 194 81 L 196 80 L 196 73 L 194 72 Z M 200 72 L 199 80 L 200 80 L 200 72 Z M 197 80 L 196 82 L 199 81 L 197 80 Z M 194 83 Q 193 86 196 85 Q 197 82 194 83 Z M 197 83 Q 196 86 199 85 Q 200 82 197 83 Z M 161 86 Q 159 91 164 90 Q 167 91 166 95 L 170 95 L 170 94 L 161 86 Z M 196 86 L 197 88 L 199 88 L 196 86 Z M 285 96 Q 284 99 288 98 Q 289 95 285 96 Z M 147 104 L 147 106 L 149 107 L 148 109 L 151 108 Q 153 109 152 106 L 147 104 Z M 302 111 L 302 130 L 304 131 L 305 128 L 305 112 L 302 111 Z M 209 125 L 209 128 L 217 128 L 217 127 Q 215 123 209 125 Z M 221 125 L 221 129 L 223 129 L 224 127 L 221 125 Z M 288 152 L 291 155 L 294 154 L 296 154 L 296 152 L 293 153 L 288 152 Z M 296 155 L 294 157 Q 293 159 296 158 L 296 155 Z M 302 160 L 302 165 L 304 165 L 304 160 L 302 160 Z M 225 166 L 224 171 L 228 170 Q 231 171 230 168 L 225 166 Z M 230 170 L 230 172 L 223 172 L 223 177 L 231 177 Q 230 174 234 175 L 232 172 Q 233 169 230 170 Z M 198 184 L 199 186 L 200 186 L 198 184 Z M 199 187 L 198 191 L 200 191 L 199 187 Z M 164 210 L 162 213 L 167 212 Q 168 209 166 210 L 164 210 Z M 166 213 L 164 214 L 164 215 L 167 214 L 166 213 Z "
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 5 L 245.5 7 L 252 7.5 L 248.5 10 L 244.5 8 Q 241.2 9.1 242 6.5 L 241 6.5 L 238.5 10 L 236.5 10 L 232.5 8 L 232 10 L 226 9.5 L 229 8.5 L 224 7.5 L 238 7 L 238.5 9 L 241.5 5 Z "
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 6 L 145.5 8 L 148.5 7 L 148.5 8 L 145.5 9 Q 142.5 7.5 145.5 6 Z "
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 7 L 135 8.5 L 133.5 9 L 132.5 7 Z "
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 7 L 168 8.5 L 163.5 10 L 163.5 9 L 165 8.5 L 163.5 7 Z "
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 8 L 114.5 10 L 113.5 8 Z "
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 8 L 152.5 10 L 150 9.5 L 151.5 8 Z "
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 8 L 159.5 10 L 158.5 8 Z "
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 8 L 188.5 10 L 187.5 8 Z "
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 8 L 219 11 L 216 9.5 L 218 9.5 L 218.5 8 Z "
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 8 L 223.5 10 Q 220.7 10.7 222.5 8 Z "
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 9 L 118 11.5 L 116 10.5 L 116.5 9 Z "
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 9 L 156 11 L 154 10.5 L 155.5 9 Z "
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 9 L 176 12.5 L 175.5 14 L 173.5 11 L 175 10.5 L 174.5 9 Z "
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 9 L 206 11 L 203 12.5 L 202.5 14 L 202 12.5 L 205.5 9 Z "
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 9 L 208.5 11 L 207.5 9 Z "
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 10 L 107.5 12 L 106.5 10 Z "
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 10 L 196.5 12 Q 193.7 12.7 195.5 10 Z "
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 12 L 118.5 14 L 119.5 12 Z "
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 12 L 152.5 13 L 154.5 12 L 154 13.5 Q 154.8 15.8 152.5 15 L 149.5 12 Z "
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 14 L 105 15.5 L 104.5 17 L 104 15.5 L 105.5 14 Z "
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 16 L 179 24 L 177 23.5 L 177.5 16 Z "
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 17 L 129.5 19 Q 126.7 19.7 128.5 17 Z "
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 17 L 142.5 19 L 141.5 17 Z "
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 17 L 152 18.5 L 151.5 21 L 149 19.5 L 151 19 L 151.5 17 Z "
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 17 Q 239.3 15.7 238 19 L 232 18.5 L 234.5 17 Z "
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 17 L 248.5 19 L 249.5 17 Z "
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 18 L 207.5 20 L 208.5 18 L 209 22 L 204 20 L 204.5 18 Z "
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 19 L 147 19.5 L 144.5 21 L 145.5 19 Z "
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 20 L 168.5 22 L 167.5 20 Z "
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 20 L 205 22.5 L 203.5 23 L 201.5 20 Z "
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 20 Q 230.8 19.3 230 21.5 L 231 23.5 L 229 22.5 L 228.5 20 Z "
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 21 L 140 22.5 L 138.5 23 L 137.5 21 Z "
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 21 L 183 23.5 L 182 23.5 L 182.5 21 Z "
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 22 L 149.5 25 L 151.5 22 L 152 23.5 Q 147.7 25.8 149.5 28 L 148 25 L 144.5 26 L 144.5 25 L 146 24.5 L 144 23.5 L 145.5 22 Z "
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185 22 L 187 22.5 L 187 31.5 L 186 31.5 Q 186.9 24.7 185 22 Z "
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 24 L 126 26 L 123 25.5 L 125.5 24 Z "
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 24 L 163 26.5 L 162 26.5 L 162.5 24 Z "
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 24 L 205.5 27 Q 202.5 25.5 205.5 24 Z "
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 24 L 241 24.5 Q 241.8 26.8 239.5 26 L 238.5 24 Z "
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 25 L 116 29.5 L 114.5 29 L 112.5 30 L 113 28.5 L 112.5 25 Z "
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 25 L 154 25.5 L 152 26.5 L 153 29 L 151 28.5 L 152.5 25 Z "
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 25 L 181.5 26 Q 182.8 23.7 184 26.5 L 183.5 28 L 176.5 28 L 178.5 25 Z "
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 26 L 101.5 28 L 102.5 26 Z "
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 27 L 131 29 L 129 28.5 L 130.5 27 Z "
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 27 L 197.5 29 L 196.5 27 Z "
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 28 L 155 31 L 152 30.5 L 154 30 L 154.5 28 Z "
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 29 L 100 32.5 L 99 32.5 L 98.5 29 Z "
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 30 L 126 32.5 L 125 32.5 L 124.5 30 Z "
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 30 L 239 31.5 Q 240.1 34.8 237.5 34 L 237.5 31 L 239.5 30 Z "
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 31 Q 184.5 29.5 184 32.5 L 182.5 32 Q 177.8 30.7 176.5 33 L 177.5 31 Z "
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137 32 L 139 32.5 L 137 35.5 L 138 37.5 L 135.5 39 L 136.5 36 L 135 35.5 L 137 32 Z "
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171 32 Q 176.2 30.3 175 34 L 172 35.5 L 169.5 39 Q 164 40 163 36.5 L 166.5 36 L 166.5 37 L 165 37.5 L 168 38 Q 169.7 33.9 165.5 35 L 165.5 34 L 169.5 35 L 171 32 Z "
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 32 L 250 39.5 L 249.5 42 Q 246.8 40.8 249 39.5 L 249.5 32 Z "
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 33 L 135 33.5 L 132.5 35 L 133.5 33 Z "
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 34 L 99 36.5 L 98 36.5 L 98.5 34 Z "
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 35 L 126.5 37 L 127.5 35 Z "
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 35 L 217 39.5 L 216 39.5 L 216.5 35 Z "
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 35 L 221 37.5 L 220 37.5 L 220.5 35 Z "
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 36 Q 199.7 38.3 199 44.5 L 198 44.5 L 197.5 43 L 196.5 48 L 196 43.5 L 197 38.5 L 196.5 36 Z "
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 36 L 201.5 38 Q 198.7 38.7 200.5 36 Z "
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 37 L 114 38.5 L 112 39.5 L 113.5 37 Z "
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 37 L 127.5 39 L 128.5 37 Z "
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 38 L 109.5 39 L 111 38.5 L 108 40 L 105.5 45 L 106 43.5 L 108 39.5 L 107.5 38 Z "
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 38 L 219 41.5 L 218 41.5 L 218.5 38 Z "
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161 39 L 164 40.5 L 165 44.5 L 164 44.5 L 162.5 42 Q 159.5 42.7 161 39 Z "
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 40 L 155 41.5 L 153 42.5 L 154.5 40 Z "
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 40 L 173 41.5 Q 172.3 43.8 174.5 43 L 174.5 44 L 170.5 40 Z "
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 40 L 184.5 42 L 185.5 40 Z "
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 40 L 195 42.5 L 194 42.5 L 194.5 40 Z "
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 40 L 246 43.5 L 245 43.5 L 244.5 40 Z "
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 42 L 187 45 L 189 45.5 L 187 46.5 L 185 43.5 L 186.5 42 Z "
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 43 L 112 44 L 111.5 46 L 109.5 45 L 108 45.5 L 109.5 43 Z "
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 44 L 148.5 46 L 149.5 44 Z "
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 44 L 249.5 46 L 248.5 44 Z "
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 46 L 125.5 49 L 121 48.5 L 125.5 46 Z "
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 46 L 131.5 48 L 130 47.5 L 132.5 46 Z "
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 50 Q 143.8 48.8 145 51.5 L 143.5 51 Q 137.5 52.3 138.5 50 Z "
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 53 Q 131.8 54.8 128 56.5 L 129 58.5 L 127 57.5 L 128.5 53 Z "
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 56 L 145.5 58 L 144 58 L 143.5 60 L 138.5 60 L 139.5 58 L 143 59 L 144.5 56 Z "
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 60 L 127.5 62 L 128.5 60 Z "
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 67 L 102.5 70 L 100.5 71 L 100 69 L 104.5 67 Z "
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 69 L 98 72.5 L 96 71.5 L 96.5 69 Z "
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 72 L 91 73.5 L 89.5 73 L 88.5 72 Z "
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 72 L 95.5 74 L 94.5 72 Z "
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 72 Q 187.9 70.5 187 73.5 L 185.5 73 Q 182.5 73.5 183.5 72 Z "
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 73 L 83 76.5 L 82.5 78 L 82 76.5 L 85.5 73 Z "
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 73 L 143.5 73 L 144 75 L 135 74.5 L 136.5 73 Z "
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 73 L 148 73.5 L 145.5 74 L 145.5 73 Z "
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 74 L 132 74.5 L 129.5 75 L 129.5 74 Z "
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 74 L 159 75 L 158 77.5 L 160.5 78 L 162.5 77 L 162.5 78 L 161 78.5 L 163 79.5 L 161.5 80 L 159.5 79 L 160.5 81 L 170 86.5 Q 169.3 89.1 172 88 L 172 90.5 L 174.5 94 L 178 94.5 L 176 97.5 L 179.5 99 L 183 97 L 183.5 99 L 192 96 Q 190.7 99.3 195.5 98 L 195.5 99 L 190.5 100 L 186.5 98 L 185 101 L 190 101 L 190 102.5 L 186 104 L 185.5 107 L 184 106.5 L 183.5 112 L 181 103 L 175 103 L 175 110.5 L 173 111 L 173 113.5 L 172 113.5 L 170.5 111 L 166.5 113 L 166 111 L 159.5 112 L 155.5 111 L 153.5 111 L 144 108.5 L 145 105.5 L 143.5 104 L 140 105 L 141 102.5 Q 136.9 98.4 128 100 L 129 104.5 L 128 107.5 Q 127.2 110.5 131 109 Q 129.9 106.3 132.5 107 L 134.5 106 L 134.5 107 L 131.5 109 L 127.5 111 L 119.5 112 L 116 111 L 115.5 113 L 115 111 Q 109 109 111 115 L 114 115.5 L 111 116 L 113 120.5 L 111 120.5 L 111.5 125 L 113 124.5 Q 113.7 127.1 111 126 L 111 130.5 L 113 130.5 Q 109.7 134.2 111 142.5 L 111 144.5 L 112.5 147 L 116 148.5 L 114.5 149 L 111 148.5 L 111 161 L 117.5 161 L 119 158.5 L 117 155 L 120 156.5 L 121.5 160 L 123 159.5 L 123 161 L 127 161 Q 125.9 163.7 128.5 163 L 128.5 164 Q 125.9 163.2 127 166.5 L 127 168.5 L 127.5 170 L 135.5 170 L 135.5 171 L 128.5 171 L 128 173 L 132 173.5 L 127 174 L 127.5 177 L 143.5 177 L 146.5 176 Q 153.5 177.5 153 174.5 L 153 172.5 L 151 169.5 L 152.5 170 Q 155.1 169.2 154 172.5 Q 154.5 175.5 158.5 175 L 160 173.5 L 161 162 L 159 161.5 L 162.5 159 L 163 161 L 168.5 161 L 169 159.5 L 170.5 160 L 173.5 159 L 174.5 161 L 176 160.5 Q 174.5 164.9 177.5 164 L 179 161.5 L 178.5 160 Q 181.5 159.1 180 163.5 L 179 167 L 175 167 L 175 176 L 179 176.5 L 176 178 L 175 184 L 177 184.5 L 175.5 185 L 172.5 184 L 172.5 185 L 174 185.5 L 171 187 Q 172.3 182.9 169 184 L 170 186.5 L 168 187 L 168.5 189 L 172.5 188 L 172.5 189 L 168 190.5 L 168.5 192 L 166.5 191 L 154 191 L 153.5 194 L 153 192 L 128.5 191 L 126 192.5 L 128 193.5 L 126.5 194 L 125 191 Q 116.8 189.2 113.5 193 L 110.5 192 L 108 191.5 L 110.5 191 L 112 191.5 Q 113.3 185.8 110 184.5 L 112 184.5 L 113 175 L 109 175 L 109 176.5 L 108 178.5 L 109 181 Q 105.9 181.8 106.5 179 L 100.5 179 L 97 177 Q 98.1 174.3 95.5 175 L 91 165 Q 94.7 163.7 93 169.5 L 94 172 L 96 171.5 L 96 164.5 L 97 160.5 L 96 159.5 L 96 152 L 88 152 L 88 159.5 L 85.5 163 L 84.5 161 Q 86.8 161.8 86 159.5 L 84 158.5 Q 84.7 161.1 82 160 L 79 150.5 L 80.5 151 L 87.5 151 L 88 149 L 80.5 149 L 80 147 L 87.5 147 L 88 145 Q 81.1 146 78 144 L 81 125.5 L 78 124.5 L 81 119.5 L 81 117.5 Q 81.3 112.8 84.5 111 L 84 112.5 L 84.5 118 L 87 113 L 92.5 112 L 95.5 113 Q 97.8 112.3 97 108.5 L 96 105.5 L 97 104.5 L 97 97 L 109.5 96 L 111.5 97 L 113 93.5 L 112 92.5 L 112 86 Q 108.3 84.7 110 90.5 L 107.5 94 L 107 92.5 L 110.5 85 Q 113.1 85.8 112 82.5 L 113 80 L 115.5 79 L 117.5 80 L 119 79.5 Q 118.4 82.3 124.5 81 L 125.5 80 L 155 79.5 L 150 78.5 L 155 78 L 154 75.5 L 155.5 74 Z M 127 95 L 127 99 L 135 99 L 137 97 L 137 95 L 127 95 Z "
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 75 L 123 77 L 120 76.5 L 122.5 75 Z "
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 75 L 129 76 L 128.5 78 L 124.5 76 L 124.5 75 Z "
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132 76 L 135 77.5 L 132 78 L 132 76 Z "
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 76 L 152 76.5 L 149.5 77 L 149.5 76 Z "
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124 77 Q 127 76 126 79 Q 123 80 124 77 Z "
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 80 L 87 80.5 L 84.5 82 L 85.5 80 Z "
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 80 L 171 80.5 L 170 81.5 L 173.5 86 L 171.5 87 L 171 85.5 Q 173.3 84.3 170.5 83 L 169 83.5 L 168.5 80 Z "
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 82 L 80.5 84 Q 77.7 84.7 79.5 82 Z "
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 85 L 84 85.5 L 81.5 87 L 82.5 85 Z "
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 85 L 176 87.5 L 175 87.5 L 175.5 85 Z "
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 87 L 182 92.5 L 180 93.5 L 180.5 87 Z "
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185 92 L 187 92.5 L 185 93.5 L 185 92 Z "
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 92 L 192 93.5 L 189 95 L 189.5 93 L 191 93.5 L 191.5 92 Z "
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 94 L 95.5 96 L 94.5 94 Z "
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 271.5 96 L 272.5 98 L 271.5 96 Z "
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 97 L 210.5 98 L 212 97.5 L 211.5 99 L 215 99.5 L 210.5 103 L 210 101 L 212 100.5 L 208.5 99 L 207.5 97 Z "
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 275.5 97 L 276 100 L 274 99.5 L 275.5 97 Z "
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 98 L 207 101 L 205 101.5 L 206 104 L 204 104 Q 205.1 101.3 202.5 102 L 202.5 101 Q 206.5 102.1 205.5 98 Z "
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 98 L 232 100.5 L 230.5 104 Q 228.3 104.8 229 102.5 L 228.5 101 L 230.5 102 L 229.5 100 L 227 99.5 L 231.5 98 Z "
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 99 Q 92.8 98.3 92 100.5 L 90.5 99 Z "
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 99 L 252 99.5 L 249.5 101 L 250.5 99 Z "
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 100 L 73.5 102 L 72.5 100 Z "
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 100 L 200 100.5 L 197.5 101 L 197.5 100 Z "
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 102 L 91 102.5 L 87.5 105 L 89.5 102 Z "
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 102 L 283 104.5 L 282 104.5 L 281.5 102 Z "
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 104 L 138 105 Q 139 108 136 107 Q 137.1 104.3 134.5 105 L 134.5 104 Z "
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 105 L 238 108.5 L 236 109 L 236.5 105 Z "
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 108 L 85.5 110 L 84.5 108 Z "
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 108 Q 233.1 107.2 232 110.5 L 231 112.5 L 235 115.5 L 233 116.5 L 234.5 119 L 232 118.5 L 232.5 117 Q 229.9 116.2 231 119.5 L 230 119.5 L 232 114.5 L 230 110.5 L 230.5 108 Z "
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 108 L 243 108.5 L 240.5 110 L 241.5 108 Z "
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 111 L 239 112.5 L 237 113 L 236.5 115 L 236 113.5 L 236.5 111 Z "
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 112 L 186 168 L 181 171.5 L 180.5 176 L 180 170.5 L 181 167 L 185 164.5 L 185.5 112 Z "
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177 113 L 179 113.5 L 179 128 L 176 127.5 Q 178.5 126 177 120.5 L 174 118.5 Q 177.8 117.2 177 113 Z "
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 113 L 188 158.5 L 187 158.5 L 187.5 113 Z "
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257 113 L 271.5 113 L 272 115.5 L 272.5 117 L 271 116.5 L 271 125.5 L 274 126 L 274 128 L 271.5 127 L 257.5 127 L 256 127.5 L 256 125.5 L 257 118.5 L 255.5 116 Q 258.5 116.7 257 113 Z "
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 114 L 123 114.5 L 120.5 115 L 120.5 114 Z "
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 114 L 169 116.5 L 167 117 L 166.5 119 L 166 117 L 162 115.5 L 163.5 115 L 167 116 L 167.5 114 Z "
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 116 L 217 116.5 L 214.5 117 L 214.5 116 Z "
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 118 L 255.5 120 L 254.5 118 Z "
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 119 L 118 120.5 L 116.5 120 Q 113.9 119.2 115 122.5 L 114 122.5 L 115.5 119 Z "
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 120 L 164 120 L 164 123 Q 166.7 121.9 166 124.5 L 163 122.5 Q 163.8 120.3 161.5 121 L 161.5 120 Z "
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 120 L 209 121.5 L 207 122.5 L 208.5 120 Z "
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 295.5 120 L 295 121.5 L 294.5 123 L 294 121.5 L 295.5 120 Z "
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 277.5 122 L 280 123 Q 281.5 126.7 278.5 126 Q 274 124 277.5 122 Z "
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 127 L 232.5 129 L 231.5 127 Z "
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 128 L 79 132.5 L 78 132.5 L 78.5 128 Z "
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 128 L 167 130.5 L 165 129.5 L 165.5 128 Z "
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 128 L 208 129.5 L 207.5 132 L 207 129 L 205.5 128 Z "
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294 128 L 296 128.5 L 294 129.5 L 294 128 Z "
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 129 L 273 129.5 L 252.5 130 L 252.5 129 Z "
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 274.5 129 L 279 129.5 L 274.5 130 L 274.5 129 Z "
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 132 L 170 139.5 L 169 139.5 L 169.5 132 Z "
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 133 L 114 136.5 L 112 135.5 L 113.5 133 Z "
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 134 L 299 139.5 L 296 141.5 L 295 138.5 L 297 138.5 L 297.5 134 Z "
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 139 L 113 141.5 L 112 141.5 L 112.5 139 Z "
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 140 L 205 142.5 L 204 142.5 L 204.5 140 Z "
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 264.5 142 L 272 142.5 L 264.5 143 L 264.5 142 Z "
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 275.5 142 L 280 142.5 L 275.5 143 L 275.5 142 Z "
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177 144 L 179 144.5 L 179 152 Q 175.2 150.5 176 153.5 L 175 153.5 L 174 149.5 L 175 149.5 L 175.5 151 L 177 144 Z "
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 144 L 204 159.5 L 203 159.5 L 203.5 144 Z "
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 144 L 249 147.5 L 246 147.5 L 247.5 144 Z "
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 147 L 166 148.5 L 165.5 150 L 165 148.5 L 166.5 147 Z "
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246 149 L 252 149.5 L 248.5 152 L 246 151 L 246 149 Z "
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 151 L 170 154 L 173 155.5 L 171.5 155 Q 168.2 153.9 169 156.5 L 167.5 156 Q 162.1 154.1 163 157.5 L 162 157.5 L 161.5 156 L 160 156.5 L 163.5 153 L 165.5 155 L 169 155 L 169.5 151 Z "
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232 153 Q 234.7 151.9 234 154.5 L 233 158.5 L 234.5 161 L 232 160 L 232 153 Z "
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252 154 Q 255 153 254 156 Q 251 157 252 154 Z "
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 284.5 154 L 285 155.5 L 282 157.5 L 284.5 154 Z "
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 156 L 251.5 158 L 250.5 156 Z "
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253 157 L 256 157.5 L 253.5 159 L 253 157 Z "
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 158 L 66.5 161 L 68 161.5 L 66.5 163 L 64 162.5 L 67.5 158 Z "
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 268.5 161 L 271 161.5 L 268.5 162 L 268.5 161 Z "
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 277.5 161 L 278 163 L 275 162.5 L 277.5 161 Z "
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 162 L 205 167.5 L 204 167.5 L 204.5 162 Z "
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 163 L 69.5 165 L 68 164.5 L 69 167.5 L 68 167.5 L 67 164.5 L 68.5 163 Z "
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 164 Q 155.9 162.1 155 165.5 L 156 168 L 158 168.5 L 156.5 169 L 153.5 165 Q 149.5 165.8 150.5 164 Z "
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 165 L 135 166.5 Q 133.5 169.5 132 166.5 L 134 166.5 L 134.5 165 Z "
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 166 L 86.5 168 L 87.5 166 Z "
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 166 Q 189.3 172.3 192 175.5 L 190 176.5 L 189.5 166 Z "
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 167 L 240.5 169 L 239.5 167 Z "
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 172 L 66.5 174 L 65.5 172 Z "
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 172 L 73.5 174 L 72.5 172 Z "
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 172 Q 241.8 171.3 241 173.5 L 239.5 172 Z "
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 284 172 L 287 172.5 L 285 173 L 283.5 176 L 284 174.5 L 284 172 Z "
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 173 L 186 175.5 L 185 175.5 L 185.5 173 Z "
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 173 L 281.5 175 L 282.5 173 Z "
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73 175 L 75 175.5 L 72.5 179 L 72 177.5 L 73 175 Z "
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 178 L 183 179 L 180.5 183 L 180 180.5 L 179.5 178 Z "
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 180 L 74.5 182 L 75.5 180 Z "
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 182 L 79 183.5 Q 77 181.8 75 185.5 L 76 188.5 L 74.5 189 L 72 187.5 L 76.5 182 Z "
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 183 L 182 184.5 L 180 185 L 178.5 188 L 178.5 183 Z "
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 185 Q 82.8 184.3 82 186.5 L 80.5 185 Z "
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 186 L 177 188.5 L 174.5 191 L 171.5 192 L 171.5 191 L 176 188.5 Q 173.8 187.3 176.5 186 Z "
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 187 L 109.5 188 L 111 187.5 L 108.5 189 L 107.5 187 Z "
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 188 L 105.5 190 L 104.5 188 Z "
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82 191 L 85 191.5 L 83.5 195 L 82 191 Z "
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 193 L 149 194.5 L 144.5 195 L 143.5 193 Z "
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 194 L 119 194.5 L 116.5 195 L 116.5 194 Z "
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 195 L 92 196 L 94 199.5 L 91.5 200 L 89 198.5 L 91 197.5 L 88 196.5 L 88 195 Z "
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 195 L 122.5 197 L 121.5 195 Z "
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 195 L 127 196.5 L 126.5 199 Q 123.9 199.8 125 196.5 L 126.5 195 Z "
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 197 L 151.5 199 L 150 198.5 L 152.5 197 Z "
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 198 L 84 200 L 82 199.5 L 83.5 198 Z "
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 199 L 148 199.5 L 145.5 200 L 145.5 199 Z "
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 200 L 99 201 L 97.5 204 L 96.5 201 L 95.5 200 Z "
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 201 L 183 202.5 L 182.5 204 L 182 202.5 L 183.5 201 Z "
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 202 L 101.5 205 L 103 204.5 L 102.5 206 L 105 207.5 L 103.5 207 L 101.5 208 L 101.5 206 Q 98 206.8 100.5 202 Z "
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 203 L 179 204.5 L 178.5 206 L 178 204.5 L 179.5 203 Z "
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 208 Q 116.6 210.8 120 210 L 118.5 213 Q 115.5 213.7 117 210 L 115 210 L 115.5 208 Z "
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 211 L 122 213.5 L 121 213.5 L 121.5 211 Z "
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 211 Q 159.8 210.3 159 212.5 L 157.5 211 Z "
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 212 L 156 213.5 L 152 214 L 152.5 212 Z "
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 213 L 134 213.5 L 131.5 214 L 131.5 213 Z "
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 213 L 145 215.5 L 144 215.5 L 143.5 213 Z "
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 213 L 149 213.5 L 146.5 214 L 146.5 213 Z "
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143 218 L 145 218.5 L 144 222 L 129.5 222 L 129 224.5 L 128 224.5 Q 129.5 220.1 126.5 221 L 126.5 220 L 128.5 219 L 129 221 L 140.5 221 L 143 220 L 143 218 Z "
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(11,43,100)",
    stroke: "rgb(11,43,100)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 218 L 152 218.5 L 149.5 219 L 149.5 218 Z "
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,251,253)",
    stroke: "rgb(246,251,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 13 L 115 14.5 L 126 43.5 L 123 44 Q 123 38.2 119.5 35 L 107.5 35 L 106.5 34 L 101.5 44 L 100 43.5 L 104 32.5 L 107 28.5 L 107 26.5 L 110 16.5 L 112.5 13 Z M 113 16 L 107 31 L 109 34 L 110 33 L 119 33 L 115 20 L 113 16 Z "
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,251,253)",
    stroke: "rgb(246,251,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 13 L 146.5 13 L 147 15 L 140.5 14 L 134 18.5 L 134 22.5 L 137.5 27 L 139.5 27 L 148 32.5 L 149 38.5 L 145.5 43 Q 141.7 45.7 133.5 44 L 132 41 Q 134.6 43.7 141.5 43 L 145 42 L 146 38 L 148 37.5 L 145 32 Q 137.3 29.5 132 23.5 Q 130.9 15.9 135.5 14 L 137.5 13 Z "
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,251,253)",
    stroke: "rgb(246,251,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157 13 L 166.5 13 L 169.5 15 L 171.5 15 Q 173.8 14.3 173 16.5 Q 176.5 18 175 24.5 L 169.5 31 L 159 32 L 159 43.5 L 157 44 L 157 13 Z M 159 15 L 159 30 Q 167 31 172 28 L 171 27 L 173 26 L 173 24 L 172 19 L 169 15 L 159 15 Z "
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,251,253)",
    stroke: "rgb(246,251,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190 13 L 195 16.5 L 210.5 40 Q 212.8 40.8 212 38.5 L 211 36.5 L 211 34.5 L 211 13.5 L 212.5 13 Q 215.3 14.3 213 15.5 L 214 34.5 L 214 36.5 L 213 42.5 L 213.5 44 Q 209.5 44.5 209 41.5 L 205 35.5 L 205.5 34 L 202 31.5 L 192.5 17 Q 190.3 16.3 191 18.5 L 192 19.5 L 192 44 L 190 43.5 L 190 13 Z "
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,251,253)",
    stroke: "rgb(246,251,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223 13 L 237.5 13 L 238 15 L 225 15 L 225 26.5 Q 226.3 29.3 227.5 27 L 232.5 28 L 237 27 L 236.5 29 L 226.5 29 L 225 30.5 L 225 41.5 Q 226.3 44.3 227.5 42 L 232.5 43 L 235.5 42 Q 240.3 40.7 239 44 L 223 44 L 223 13 Z "
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,251,253)",
    stroke: "rgb(246,251,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243 13 L 263.5 13 L 264 15 L 255 15 L 255 39.5 L 255 41.5 Q 256.3 45.3 252.5 44 L 252.5 43 L 254 42.5 L 253 41.5 L 253 15 L 243.5 15 L 243 13 Z "
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,251,253)",
    stroke: "rgb(246,251,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178 41 Q 182.5 39.5 181 44 Q 176.5 45.5 178 41 Z "
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,251,253)",
    stroke: "rgb(246,251,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 63 L 154.5 64 L 168.5 68 L 176 72 L 176.5 74 L 178 73.5 L 177.5 75 L 179.5 74 L 192 83 L 190.5 86 L 186.5 89 L 181 83.5 L 181.5 82 L 179.5 83 L 174.5 79 L 161.5 73 L 147.5 70 L 133.5 70 L 123.5 72 L 108.5 78 L 91 92.5 L 82.5 105 L 81 105.5 L 82 107.5 L 77 118.5 L 75 134.5 L 75 136.5 L 76 149.5 L 83 169.5 Q 89.7 180.8 99.5 189 Q 110.2 197.8 125.5 202 L 130.5 203 L 150.5 203 L 165.5 199 L 170.5 196 L 172 196.5 L 173.5 194 L 187.5 185 L 192 189.5 L 189.5 192 L 175.5 202 L 160.5 208 L 151.5 210 L 130.5 210 L 120 208 L 119.5 206 L 117.5 207 Q 105.9 203.6 98 196.5 L 97.5 195 L 96.5 196 L 93.5 193 L 87 187.5 L 85 184.5 L 81 180.5 L 75 169.5 L 75.5 168 Q 73.3 168.8 74 166.5 L 71 160.5 L 68 147.5 L 68 126.5 L 72 110.5 Q 76.3 98.8 83.5 90 Q 85.8 90.8 85 88.5 L 88.5 84 L 90.5 84 L 92 83.5 L 91 82.5 L 96.5 77 L 108.5 70 L 110.5 71 L 110.5 69 L 112 69.5 Q 111.2 66.9 114.5 68 L 132.5 63 Z M 189 84 L 187 86 L 189 86 L 189 84 Z "
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,251,253)",
    stroke: "rgb(246,251,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 103 L 224.5 103 L 226 104.5 L 225.5 112 Q 222.9 108.6 215.5 110 L 206 117.5 L 201 130.5 L 201 172 L 193.5 172 L 193 171.5 L 193 104 L 201 104 L 201 114.5 L 200 118.5 L 203 116.5 L 204 112 Q 206.7 113.1 206 110.5 L 207 108 L 216.5 103 Z "
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,251,253)",
    stroke: "rgb(246,251,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 258.5 103 Q 268.8 101.7 275.5 104 L 285 110.5 L 289 116.5 L 292 126.5 L 292 139.5 L 290.5 139 L 243.5 139 L 242 140.5 L 245 154.5 L 251.5 163 L 258.5 167 L 263.5 168 L 264.5 167 L 273.5 167 L 287.5 160 L 288 161.5 L 288 163.5 Q 288.8 168.3 285.5 169 L 281.5 171 L 280 170.5 Q 280.8 173.1 277.5 172 L 270.5 174 L 259.5 174 L 254.5 173 L 247 168.5 L 246.5 167 Q 244.7 169.8 243 165.5 L 241 162.5 L 236 152.5 L 234 136.5 L 237 122.5 Q 240.2 114.2 246.5 109 L 253.5 105 L 255 105.5 Q 254.2 102.9 257.5 104 L 258.5 103 Z M 263 109 L 253 113 L 247 119 L 242 132 L 244 133 L 284 133 Q 286 123 281 118 Q 276 109 263 109 Z M 287 163 L 285 165 L 287 165 L 287 163 Z "
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 12 L 115 12.5 L 112.5 13 L 112.5 12 Z "
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 12 L 168 12.5 L 157.5 13 L 156.5 14 L 157.5 12 Z "
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 12 L 193 12.5 L 189.5 13 L 189.5 12 Z "
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 12 L 214 12.5 L 211.5 13 L 211.5 12 Z "
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 12 L 237.5 12 L 239 13.5 L 237.5 16 L 226 15.5 L 238 15 L 237.5 13 L 223.5 13 L 223.5 12 Z "
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 12 L 263.5 12 L 265 13.5 L 263.5 16 L 255 15.5 L 264 15 L 263.5 13 L 243.5 13 L 243.5 12 Z "
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 13 L 134.5 15 L 135.5 13 Z "
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 14 L 194.5 16 L 193.5 14 Z "
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 15 L 168 15.5 L 160.5 16 L 160.5 15 Z "
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 15 L 250 15.5 L 243.5 16 L 243.5 15 Z "
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 16 L 171.5 19 L 169.5 16 Z "
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 18 L 132 22.5 L 131 22.5 L 131.5 18 Z "
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 18 L 193.5 20 L 192.5 18 Z "
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 19 L 135 21.5 L 134 21.5 L 134.5 19 Z "
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 20 L 176 22.5 L 175 22.5 L 175.5 20 Z "
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 21 L 199.5 23 L 198.5 21 Z "
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 22 L 196.5 24 L 195.5 22 Z "
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 26 L 135.5 28 L 134.5 26 Z "
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 27 L 203.5 29 L 202.5 27 Z "
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 27 L 238 28.5 L 236.5 30 L 226.5 30 L 226.5 29 L 236.5 29 L 237.5 27 Z "
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 28 L 200.5 30 L 199.5 28 Z "
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 30 L 147.5 32 L 146.5 30 Z "
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 31 L 108.5 33 L 107.5 31 Z "
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 31 L 117.5 33 L 110 32.5 L 118.5 31 Z "
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 35 L 205.5 37 L 204.5 35 Z "
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 38 L 207.5 40 L 206.5 38 Z "
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 39 L 143.5 42 L 142 41.5 L 145.5 39 Z "
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 40 L 145.5 44 L 148.5 40 Z "
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 41 L 234 41.5 L 229.5 42 L 229.5 41 Z "
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 42 L 182 43.5 L 180 44.5 L 181.5 42 Z "
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 43 L 103 44.5 L 99 45 L 99.5 43 Z "
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 43 L 125.5 45 L 123 44.5 L 126.5 43 Z "
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 43 L 160 44.5 L 157.5 45 L 156.5 43 Z "
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 43 L 178.5 45 L 177.5 43 Z "
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 43 L 223.5 44 L 239 44.5 L 223.5 45 L 222.5 43 Z "
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 44 L 192 44.5 L 189.5 45 L 189.5 44 Z "
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 44 L 214 44.5 L 211.5 45 L 211.5 44 Z "
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 44 L 255 44.5 L 252.5 45 L 252.5 44 Z "
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 62 L 147 62.5 L 134.5 63 L 134.5 62 Z "
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 70 L 145 70.5 L 136.5 71 L 136.5 70 Z "
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 75 L 183.5 77 L 182.5 75 Z "
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 77 L 93.5 80 L 95.5 77 Z "
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 78 L 188.5 81 L 186.5 78 Z "
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 79 L 106.5 81 L 107.5 79 Z "
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 80 L 176.5 82 L 175.5 80 Z "
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 82 L 180.5 85 L 178.5 82 Z "
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 83 L 99.5 86 L 101.5 83 Z "
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 86 L 188 89.5 L 186.5 90 L 183.5 86 Z "
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 95 L 88.5 97 L 89.5 95 Z "
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 102 L 223 102.5 L 218.5 103 L 218.5 102 Z "
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 102 L 264 102.5 L 260.5 103 L 260.5 102 Z "
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 267.5 102 L 271 102.5 L 267.5 103 L 267.5 102 Z "
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 104 L 193 172.5 L 192 172.5 L 192.5 104 Z "
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 278.5 105 L 281 106.5 L 279.5 106 L 278.5 105 Z "
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 106 L 248.5 108 L 249.5 106 Z "
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 110 L 221 110.5 L 216.5 111 L 216.5 110 Z "
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 110 L 242.5 113 L 244.5 110 Z "
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 111 Q 152.8 110.8 159 119.5 L 163 128.5 L 164 139.5 L 162 148.5 L 158 156 L 156 156 Q 157.1 158.7 154.5 158 Q 148.4 163.9 135.5 163 Q 125.8 161.2 121 154.5 L 116 143.5 L 116 131.5 L 122 118 L 132.5 112 L 137.5 111 Z "
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 112 L 210.5 114 L 211.5 112 Z "
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 276.5 113 L 278.5 116 L 276.5 113 Z "
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 116 L 206.5 118 L 207.5 116 Z "
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 119 L 78 121.5 L 77 121.5 L 77.5 119 Z "
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 127 L 284 129.5 L 283 129.5 L 283.5 127 Z "
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 128 L 68 132.5 L 67 132.5 L 67.5 128 Z "
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 292.5 128 L 293 131.5 L 292 131.5 L 292.5 128 Z "
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 131 L 202 134.5 L 201 134.5 L 201.5 131 Z "
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 132 L 283 132.5 L 243.5 133 L 243.5 132 Z "
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 140 L 68 145.5 L 67 145.5 L 67.5 140 Z "
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 145 L 77 147.5 L 76 147.5 L 76.5 145 Z "
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 145 L 244 147.5 L 243 147.5 L 243.5 145 Z "
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 149 L 69 151.5 L 68 151.5 L 68.5 149 Z "
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 287.5 159 L 289 159.5 L 289 166.5 L 288 166.5 Q 288.5 160.5 287.5 159 Z "
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 161 L 253.5 164 L 251.5 161 Z "
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 165 L 245.5 169 L 242.5 165 Z "
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 166 L 263 166.5 L 260.5 167 L 260.5 166 Z "
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286.5 168 L 285.5 170 L 286.5 168 Z "
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 169 L 248.5 171 L 247.5 169 Z "
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 174 L 268 174.5 L 261.5 175 L 261.5 174 Z "
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 175 L 78.5 177 L 77.5 175 Z "
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 176 L 89.5 178 L 88.5 176 Z "
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 178 L 80.5 180 L 79.5 178 Z "
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 181 L 96.5 186 L 92.5 181 Z "
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 184 L 191.5 189 L 187.5 184 Z "
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 187 L 89.5 191 L 86.5 187 Z "
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 187 L 181.5 189 L 182.5 187 Z "
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 188 L 101.5 190 L 100.5 188 Z "
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 190 L 177.5 192 L 178.5 190 Z "
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 190 L 190.5 192 L 191.5 190 Z "
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 191 L 105.5 193 L 104.5 191 Z "
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 194 L 184.5 197 L 186.5 194 Z "
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 195 L 96.5 197 L 95.5 195 Z "
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 197 L 99.5 199 L 98.5 197 Z "
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 199 L 102.5 201 L 101.5 199 Z "
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 199 L 178.5 201 L 179.5 199 Z "
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 201 L 130 201.5 L 127.5 202 L 127.5 201 Z "
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 201 L 155 201.5 L 152.5 202 L 152.5 201 Z "
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 202 L 139 202.5 L 134.5 203 L 134.5 202 Z "
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 202 L 148 202.5 L 142.5 203 L 142.5 202 Z "
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 209 L 128 209.5 L 125.5 210 L 125.5 209 Z "
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 210 L 136 210.5 L 132.5 211 L 132.5 210 Z "
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(89,186,222)",
    stroke: "rgb(89,186,222)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 210 L 149 210.5 L 144.5 211 L 144.5 210 Z "
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 12 L 145 12.5 L 139.5 13 L 139.5 12 Z "
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 13 L 112.5 15 L 111.5 13 Z "
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 13 L 148 16 L 146 15.5 L 147.5 13 Z "
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 13 Q 170.8 11.9 170 14.5 L 168 15.5 L 168.5 14 L 167.5 13 Z "
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 13 L 190 43.5 L 189 43.5 L 189.5 13 Z "
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 13 L 192.5 16 Q 189.5 14.5 192.5 13 Z "
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 14 L 143 14.5 L 140.5 15 L 140.5 14 Z "
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 14 L 253 15.5 L 253 41.5 L 254 42.5 L 252 43 L 252 15.5 L 253.5 14 Z "
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 15 L 133 16.5 L 132.5 18 L 132 16.5 L 133.5 15 Z "
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 15 L 160 29 L 167 29.5 L 159 30 L 159.5 15 Z "
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 15 L 214 23.5 L 213 23.5 L 213.5 15 Z "
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 15 L 226 26.5 L 227 27.5 L 225 26.5 L 225.5 15 Z "
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191 17 L 194 18.5 L 191 18.5 L 191 17 Z "
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 20 L 173 23.5 L 172 23.5 L 172.5 20 Z "
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 22 L 138.5 27 L 140 26.5 Q 138 31 136 27.5 L 137 25.5 L 135 25.5 L 136 24.5 L 134.5 22 Z "
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 23 L 200.5 25 L 199.5 23 Z "
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 27 L 172.5 28 L 174 27.5 L 171 29.5 L 171.5 28 L 169.5 29 L 170.5 27 Z "
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 28 L 105.5 30 L 106.5 28 Z "
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 28 Q 204.5 29.5 201.5 31 L 201.5 28 Z "
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 30 L 226 41.5 L 227 42.5 L 225 41.5 L 225.5 30 Z "
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 32 L 110 32.5 Q 107.9 35.8 107.5 32 Z "
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 32 L 160 43.5 L 159 43.5 L 159.5 32 Z "
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 33 Q 108.5 34.5 105.5 36 L 105.5 33 Z "
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 33 L 205.5 34 L 207 33.5 L 206.5 36 L 203.5 33 Z "
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 35 L 148 37.5 L 146 38 L 146.5 35 Z "
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 37 L 104.5 39 L 103.5 37 Z "
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 38 L 212 38.5 Q 212.8 40.8 210.5 40 L 209.5 38 Z "
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 40 L 133 43.5 L 131 42.5 L 131.5 40 Z "
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 42 L 142 42.5 L 136.5 43 L 136.5 42 Z "
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 44 L 142 44.5 L 136.5 45 L 136.5 44 Z "
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 63 L 132 63.5 L 129.5 64 L 129.5 63 Z "
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 63 L 152 63.5 L 149.5 64 L 149.5 63 Z "
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 68 L 112 69.5 L 109 71 L 109.5 69 L 111 69.5 L 111.5 68 Z "
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 70 L 136 70.5 L 133.5 71 L 133.5 70 Z "
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 70 L 148 70.5 L 145.5 71 L 145.5 70 Z "
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 71 L 163.5 73 L 162.5 71 Z "
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 71 L 177 72.5 L 177.5 74 L 179 73.5 Q 179.8 75.8 177.5 75 L 176 72 L 174.5 71 Z "
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 72 L 102.5 74 L 103.5 72 Z "
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 75 L 107.5 77 L 108.5 75 Z "
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 77 L 100.5 80 L 102.5 77 Z "
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 77 L 104.5 79 L 105.5 77 Z "
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 80 L 93.5 82 Q 92.3 79.8 91 82.5 L 91.5 84 L 89.5 85 L 89 83.5 L 92.5 80 Z "
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 81 L 182 82.5 L 181 83.5 L 182.5 86 L 179.5 81 Z "
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 81 Q 192.8 82.8 189 84.5 L 190 86.5 L 187 88.5 L 188.5 86 L 186.5 85 L 185 85.5 L 186 83.5 L 185.5 82 L 188 82.5 L 187 84.5 L 190 82.5 L 189.5 81 Z "
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 85 L 85 88.5 L 84.5 90 L 84 88.5 L 87.5 85 Z "
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 85 L 91.5 93 L 98.5 85 Z "
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 86 L 91 86.5 L 89 87.5 Q 91.3 88.7 88.5 90 L 86.5 91 L 87.5 89 L 89 88.5 Q 86.8 87.3 89.5 86 Z "
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 86 L 93.5 88 L 92 87.5 L 94.5 86 Z "
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 90 L 88.5 93 L 87 92.5 L 90.5 90 Z "
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 96 L 88 97.5 L 86.5 97 L 85.5 96 Z "
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 99 L 77.5 102 L 76.5 100 Q 78 102.5 79.5 99 Z "
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 264.5 102 L 267 102.5 L 264.5 103 L 264.5 102 Z "
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 103 Q 228 104 227 108.5 L 226 108.5 L 225.5 103 Z "
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 105 L 215.5 108 Q 212.5 106.5 215.5 105 Z "
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 106 L 209.5 109 Q 206.5 107.5 209.5 106 Z "
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 106 L 253 107.5 L 251.5 108 L 249 107.5 L 250.5 106 Z "
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 107 L 75 109.5 L 74 109.5 L 73.5 107 Z "
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 107 L 225 108.5 L 223.5 108 L 222.5 107 Z "
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 109 L 206 110.5 L 206.5 112 L 209.5 110 L 208.5 112 L 207 112.5 Q 209.3 113.7 206.5 115 Q 208.1 113.3 205 111.5 L 206.5 109 Z "
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 265.5 109 L 268 109.5 L 265.5 110 L 265.5 109 Z "
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 110 L 248.5 112 L 246 111.5 L 247.5 110 Z "
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 110 L 252.5 112 L 253.5 110 Z "
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280.5 110 L 281.5 112 L 280.5 110 Z "
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 285.5 111 L 288 114.5 L 286 113.5 L 285.5 111 Z "
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 113 L 241.5 115 L 242.5 113 Z "
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 113 L 247.5 119 L 252.5 113 Z "
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 278.5 113 L 281 113.5 Q 278.9 116.8 278.5 113 Z "
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 115 L 201 118.5 L 200 118.5 L 200.5 115 Z "
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 279.5 116 L 280.5 118 L 279.5 116 Z "
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 121 L 284 126.5 L 283 126.5 L 282.5 121 Z "
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 122 L 77 124.5 L 76 124.5 L 76.5 122 Z "
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 130 L 76 134.5 L 75 134.5 L 75.5 130 Z "
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 132 L 235 135.5 L 234 135.5 L 234.5 132 Z "
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 292.5 132 L 293 139.5 L 292 139.5 L 292.5 132 Z "
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 133 L 68 139.5 L 67 139.5 L 67.5 133 Z "
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 136 L 76 140.5 L 75 140.5 L 75.5 136 Z "
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 139 L 291 139.5 L 243 140 L 242.5 142 L 242 140.5 L 243.5 139 Z "
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 141 L 235 145.5 L 234 145.5 L 234.5 141 Z "
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 158 L 78 160.5 L 76 159.5 L 76.5 158 Z "
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 160 L 251.5 163 Q 249.8 159.9 248 161.5 L 249.5 160 Z "
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286.5 160 L 285.5 162 L 286.5 160 Z "
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 161 L 240.5 163 L 241.5 161 Z "
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 161 L 244 162.5 Q 243.3 164.8 245.5 164 L 245.5 165 L 243.5 164 L 242 164.5 L 244.5 161 Z "
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 287.5 162 L 287 163.5 Q 287.8 165.8 285.5 165 L 284 165.5 L 287.5 162 Z "
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 164 L 255 166.5 L 256 168.5 L 254 167.5 L 253 165.5 L 254.5 164 Z "
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 165 L 252 166.5 L 250.5 166 L 249 166.5 L 249.5 168 Q 246.5 166.5 249.5 165 Z "
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286.5 166 L 287.5 168 L 286.5 166 Z "
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 167 L 75.5 169 L 74 168.5 L 76.5 167 Z "
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 284.5 167 L 284.5 170 Q 281.5 168.5 284.5 167 Z "
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 172 L 201 172.5 L 193.5 173 L 193.5 172 Z "
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 176 L 82.5 179 L 84.5 176 Z "
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 179 L 92 180.5 L 90 180.5 L 89.5 182 L 88.5 179 Z "
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 182 L 90.5 184 L 91.5 182 Z "
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 183 L 84.5 185 L 83.5 183 Z "
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 184 Q 89.5 185.5 86.5 187 L 86.5 184 Z "
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 184 L 185.5 186 L 186.5 184 Z "
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 185 L 91.5 187 L 92.5 185 Z "
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 186 L 99.5 189 L 97.5 186 Z "
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 189 L 99 190.5 L 96.5 192 L 96.5 190 L 95.5 189 Z "
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 189 L 184.5 191 L 185.5 189 Z "
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 192 Q 97.5 193.5 94.5 195 Q 91.5 193.5 94.5 192 Z "
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 192 L 187.5 194 L 188.5 192 Z "
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 193 Q 100.3 194.3 98 195.5 L 97.5 197 L 97 195.5 L 97.5 193 Z "
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 193 L 107 193.5 L 103.5 196 L 101 194.5 L 102.5 194 L 104.5 195 L 104.5 193 Z "
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 194 L 107.5 196 L 108.5 194 Z "
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 201 L 111.5 203 L 110.5 201 Z "
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 202 L 134 202.5 L 130.5 203 L 130.5 202 Z "
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 202 L 151 202.5 L 148.5 203 L 148.5 202 Z "
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,239,242)",
    stroke: "rgb(234,239,242)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 210 L 144 210.5 L 136.5 211 L 136.5 210 Z "
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 8 L 171 9.5 L 169.5 10 L 168.5 8 Z "
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 8 L 196.5 9 L 198.5 8 L 198 9.5 L 197.5 11 L 195.5 9 Q 193.8 12.7 192 9.5 L 193.5 8 Z "
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 9 L 133 9.5 L 132.5 11 L 136.5 9 L 136.5 10 L 134 11.5 L 133.5 13 L 130 10.5 L 131.5 9 Z "
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 10 L 109.5 12 L 110.5 10 Z "
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 10 L 219 11.5 L 217.5 12 L 216.5 10 Z "
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 11 L 143 11.5 L 140.5 12 L 140.5 11 Z "
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 11 L 242 11.5 L 240.5 15 L 239.5 12 L 238 12.5 L 239.5 11 Z "
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 12 Q 133.5 13.5 130.5 15 L 130.5 12 Z "
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 12 Q 150 13.2 149 17 L 146 16.5 L 148 16 L 147.5 12 Z "
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 12 L 200 12.5 L 199 14.5 L 199.5 16 L 197.5 12 Z "
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 12 L 211 36.5 L 210 36.5 L 210.5 12 Z "
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 12 L 223 42.5 L 222 42.5 L 222.5 12 Z "
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 13 L 215 31.5 L 214 31.5 L 214.5 13 Z "
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 13 L 243 15.5 L 242 15.5 L 242.5 13 Z "
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 14 L 132.5 16 L 133.5 14 Z "
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 14 Q 177.5 15.5 174.5 17 L 174.5 14 Z "
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 15 L 116.5 17 L 117.5 15 Z "
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 15 L 120 16.5 L 117.5 20 L 118 18.5 L 119.5 15 Z "
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 15 L 195.5 17 L 196.5 15 Z "
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 16 L 135.5 18 L 136.5 16 Z "
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 16 L 157 23.5 L 156 23.5 L 156.5 16 Z "
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 16 L 221 30.5 L 220 30.5 L 220.5 16 Z "
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 255.5 16 L 256 44.5 L 255 44.5 L 255.5 16 Z "
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 17 L 252 44.5 L 250 45.5 L 251 44.5 L 251.5 17 Z "
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 18 Q 114.8 17.3 114 19.5 L 112.5 18 Z "
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 18 L 169.5 20 L 168.5 18 Z "
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 19 L 201 20.5 L 198.5 21 L 197.5 19 Z "
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 20 L 193 46.5 L 192 46.5 L 192.5 20 Z "
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 23 L 142 25.5 L 140 26.5 L 141 24.5 L 140.5 23 Z "
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 23 L 228.5 25 L 227 24.5 L 229.5 23 Z "
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121 24 L 123 24.5 L 121 25.5 L 121 24 Z "
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 24 L 135 27.5 L 133 28.5 Q 135.3 27.2 132.5 26 L 130 27 L 129.5 24 Z "
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 25 L 157 30.5 L 156 30.5 L 156.5 25 Z "
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 25 L 207.5 27 L 206.5 25 Z "
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 26 L 146.5 27 L 148 26.5 L 147.5 28 Q 151.3 27.3 152 29.5 L 150.5 32 L 149.5 30 L 151 30.5 Q 151.9 27.5 147.5 29 L 145.5 28 L 145.5 30 L 144 28.5 L 144.5 26 Z "
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 26 L 171 26.5 Q 168.9 29.8 168.5 26 Z "
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 26 L 238 26.5 L 226.5 27 L 226.5 26 Z "
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 28 L 135.5 30 L 136.5 28 Z "
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 28 L 175 28.5 L 172.5 30 L 173.5 28 Z "
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 28 L 207 28.5 L 204.5 30 L 205.5 28 Z "
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 29 L 129.5 31 L 127 30.5 L 128.5 29 Z "
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 29 L 134 30.5 L 131.5 32 L 131.5 29 Z "
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 29 L 136.5 32 L 138.5 29 Z "
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 30 L 199.5 32 L 197 31.5 L 198.5 30 Z "
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 30 L 209 32.5 L 206 32.5 L 207.5 30 Z "
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 31 L 141.5 34 Q 138.5 32.5 141.5 31 Z "
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 32 L 144.5 34 L 143.5 32 Z "
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 32 L 157 42.5 L 156 42.5 L 156.5 32 Z "
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 32 L 166 32.5 L 160.5 33 L 160.5 32 Z "
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 34 L 202.5 36 L 203.5 34 Z "
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 34 L 215 39.5 L 214 39.5 L 214.5 34 Z "
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 35 L 109 35.5 L 106.5 36 L 106.5 35 Z "
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 35 L 120 35.5 L 110.5 36 L 110.5 35 Z "
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 36 L 140.5 38 L 141.5 36 Z "
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 37 Q 118.8 36.3 118 38.5 L 116.5 37 Z "
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 38 L 106.5 40 L 105.5 38 Z "
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 38 L 142.5 40 L 141 39.5 L 143.5 38 Z "
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 40 Q 154 42 149.5 44 L 150.5 40 Z "
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 40 L 183 40.5 Q 180.9 43.8 180.5 40 Z "
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 40 L 208.5 42 L 207.5 40 Z "
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 41 L 147.5 43 L 148.5 41 Z "
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 41 L 229 41.5 L 226.5 42 L 226.5 41 Z "
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 41 L 237 41.5 L 234.5 42 L 234.5 41 Z "
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 41 L 240 44.5 L 239 44.5 L 239.5 41 Z "
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 42 L 130 44.5 L 128 43.5 L 128.5 42 Z "
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 42 L 248.5 44 L 249.5 42 Z "
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 44 L 147.5 46 L 146.5 44 Z "
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 45 L 141 45.5 L 138.5 46 L 138.5 45 Z "
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 46 L 101.5 48 L 100.5 46 Z "
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 46 L 121.5 48 L 122.5 46 Z "
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 46 L 126.5 48 L 127.5 46 Z "
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 46 L 151.5 48 L 150.5 46 Z "
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 46 L 189.5 48 L 188.5 46 Z "
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 60 L 133 60.5 L 129.5 61 L 129.5 60 Z "
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 62 L 134 62.5 L 131.5 63 L 131.5 62 Z "
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 62 L 150 62.5 L 147.5 63 L 147.5 62 Z "
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 66 L 109 67.5 L 107.5 67 L 106.5 66 Z "
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 70 L 183 70.5 L 180.5 72 L 181.5 70 Z "
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 71 L 134 71.5 L 131.5 72 L 131.5 71 Z "
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 71 L 150 71.5 L 147.5 72 L 147.5 71 Z "
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 73 L 90.5 79 L 88 78.5 L 90 76.5 Q 86.3 74.8 89.5 73 Z "
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 73 L 185.5 75 L 187.5 74 L 187.5 77 L 184 74.5 L 185.5 73 Z "
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 74 L 93.5 75 L 97 74.5 L 96.5 77 Q 95 73.5 93.5 76 L 91.5 74 Z "
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 77 L 192 77.5 L 190 78.5 L 190.5 80 Q 187.5 78.5 190.5 77 Z "
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 79 Q 112 81 107.5 83 L 105 81.5 L 106.5 82 L 109 80.5 L 108.5 79 Z "
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 79 L 173.5 83 Q 169 81 172.5 79 Z "
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 80 L 85.5 87 L 91.5 80 Z "
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 81 L 86.5 83 L 87.5 81 Z "
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 81 L 108.5 85 L 107 85.5 L 109 86.5 L 107.5 87 L 105 85.5 L 111.5 81 Z "
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 81 L 193 84.5 L 188 88.5 L 192 83.5 L 190.5 81 Z "
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 82 L 84 83.5 L 81 85.5 L 83.5 82 Z "
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 82 L 102.5 88 L 100.5 87 L 97 87.5 L 100.5 86 L 103 84.5 Q 100.8 83.3 103.5 82 Z "
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 83 L 171.5 85 L 170.5 83 Z "
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 85 L 179.5 88 L 181.5 85 Z "
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 87 L 81.5 89 L 82.5 87 Z "
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 89 L 90.5 95 L 95.5 89 Z "
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 90 L 81.5 92 L 82.5 90 Z "
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 92 L 94.5 94 L 95.5 92 Z "
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 96 L 92.5 98 L 91.5 96 Z "
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 97 L 91 98.5 L 89.5 99 L 87 98.5 L 88.5 97 Z "
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 98 L 74.5 100 L 73.5 98 Z "
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 100 L 222 100.5 L 218.5 101 L 218.5 100 Z "
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253 100 L 255 100.5 L 253 101.5 L 253 100 Z "
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 101 L 86.5 103 L 85.5 101 Z "
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 102 L 206.5 106 L 209.5 102 Z "
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 103 L 71.5 105 L 72.5 103 Z "
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 103 L 85.5 105 L 84.5 103 Z "
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 103 L 202 103 L 202 113.5 L 202.5 115 L 201 113.5 L 201 104 L 192.5 104 L 192.5 103 Z "
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245 104 L 248 105.5 Q 246.3 103.9 244.5 107 L 243.5 106 L 241.5 107 L 242.5 105 L 244.5 106 L 245 104 Z "
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286.5 104 L 285.5 106 L 286.5 104 Z "
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 105 L 84.5 107 L 83.5 105 Z "
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 105 L 205.5 110 L 209.5 105 Z "
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 106 L 283.5 109 L 281.5 106 Z "
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 287.5 106 L 286.5 109 L 288 109.5 L 285.5 111 L 285 108.5 Q 284.3 106.3 286.5 107 L 287.5 106 Z "
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 107 L 71 108.5 L 69 109.5 L 70.5 107 Z "
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 107 L 88 109.5 L 86 108.5 L 86.5 107 Z "
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 108 L 245.5 110 L 246.5 108 Z "
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 109 L 83 111.5 L 82 111.5 L 81.5 109 Z "
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 110 L 86.5 112 L 85.5 110 Z "
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 111 L 137 111.5 L 134.5 112 L 134.5 111 Z "
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 111 L 147 111.5 L 144.5 112 L 144.5 111 Z "
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 112 L 121.5 114 L 120.5 112 Z "
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 112 L 132 112.5 L 123.5 118 L 126.5 114 L 130.5 112 Z "
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 112 L 152.5 113 L 154.5 112 L 155.5 114 L 153.5 113 L 154.5 115 L 156.5 116 L 158 115.5 L 157 116.5 L 158.5 119 Q 155.5 114 148.5 113 L 148.5 112 Z "
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 112 L 228 112.5 Q 225.9 115.8 225.5 112 Z "
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 274.5 112 L 273.5 116 Q 270 114 274.5 112 Z "
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 112 L 291 112.5 L 290 114.5 Q 292.3 115.8 289.5 117 L 289 114.5 L 288.5 112 Z "
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 113 L 159.5 115 L 158.5 113 Z "
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 113 L 239 114.5 L 237 115.5 L 238.5 113 Z "
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 113 Q 257 115 252.5 117 L 252 114.5 L 253.5 113 Z "
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 114 L 209.5 117 Q 206.5 115.5 209.5 114 Z "
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 115 L 121.5 117 L 120.5 115 Z "
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 117 L 248.5 119 L 249.5 117 Z "
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 117 L 253.5 119 L 254.5 117 Z "
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272.5 117 L 273.5 119 L 272.5 117 Z "
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 275.5 117 L 276.5 119 L 275.5 117 Z "
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 118 L 211.5 120 L 210.5 118 Z "
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 118 L 214.5 120 L 213.5 118 Z "
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 119 L 120.5 121 L 121.5 119 Z "
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 120 L 117 124.5 L 116 124.5 L 115.5 120 Z "
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 120 L 163 127.5 L 162 127.5 L 159.5 120 Z "
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 122 L 119 123.5 L 118.5 125 L 118 123.5 L 119.5 122 Z "
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 123 L 205.5 125 L 206.5 123 Z "
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 124 L 246.5 126 L 245.5 124 Z "
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 125 L 68 127.5 L 67 127.5 L 67.5 125 Z "
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 127 L 77 132.5 L 76 132.5 L 76.5 127 Z "
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 128 L 117 130.5 L 116 130.5 L 116.5 128 Z "
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 128 L 247.5 130 Q 244.7 130.7 246.5 128 Z "
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 129 L 164 135.5 L 163 135.5 L 163.5 129 Z "
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 135 L 116 140.5 L 115 140.5 L 115.5 135 Z "
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 135 L 202 172.5 L 199.5 174 L 199.5 173 L 201 172.5 L 201.5 135 Z "
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 136 L 77 144.5 L 76 144.5 L 76.5 136 Z "
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 136 L 234 141.5 L 233 141.5 L 233.5 136 Z "
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 139 L 293 140.5 L 292.5 143 L 292 141 L 289 140.5 L 293.5 139 Z "
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 140 L 164 144.5 L 163 144.5 L 163.5 140 Z "
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 140 L 244 144.5 L 243 144.5 L 243.5 140 Z "
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 140 L 288 140.5 L 246.5 141 L 246.5 140 Z "
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 144 L 80 145.5 L 78.5 148 L 78 145.5 L 79.5 144 Z "
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 144 L 117 145.5 L 115.5 148 L 115 146.5 L 116.5 144 Z "
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 146 L 68 148.5 L 67 148.5 L 67.5 146 Z "
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 149 L 78 151.5 L 77 151.5 L 77.5 149 Z "
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 149 L 162 150.5 L 160 151.5 L 161.5 149 Z "
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 150 L 67 153.5 L 66 153.5 L 65.5 150 Z "
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 152 L 121 153.5 L 119.5 153 L 118.5 152 Z "
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 152 L 246.5 155 L 248.5 152 Z "
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 153 L 160 155 L 158 154.5 L 159.5 153 Z "
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 155 L 125 158.5 L 123.5 160 L 124 158.5 L 121.5 155 Z "
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 155 L 235 157.5 L 234 157.5 L 234.5 155 Z "
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 155 L 247.5 157 L 248.5 155 Z "
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 156 L 157.5 158 L 159.5 157 L 159.5 158 L 157.5 159 L 156.5 156 Z "
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 285.5 157 L 284.5 159 L 285.5 157 Z "
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 158 L 236.5 160 L 237.5 158 Z "
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 158 L 250.5 161 L 248.5 158 Z "
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 158 L 289.5 160 L 288.5 158 Z "
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 159 L 254.5 162 L 252 161 L 252.5 159 Z "
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 160 L 135 162.5 L 131.5 163 L 128.5 160 Z "
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 161 L 150 161.5 L 148 162.5 L 148.5 164 L 144 162.5 L 148.5 161 Z "
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 163 L 143 163.5 L 137.5 164 L 137.5 163 Z "
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 163 L 241.5 165 L 240.5 163 Z "
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 164 L 136 164.5 L 134 165 L 133.5 167 L 133 165.5 L 134.5 164 Z "
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 263.5 166 L 270 166.5 L 263.5 167 L 263.5 166 Z "
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 167 L 287.5 169 L 288.5 167 Z "
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 168 L 86.5 170 L 87.5 168 Z "
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 169 L 246 171.5 L 243.5 170 L 242.5 169 Z "
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 171 L 88 171.5 Q 85.9 174.8 85.5 171 Z "
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 172 L 244.5 174 L 243.5 172 Z "
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 172 L 249.5 175 L 247.5 172 Z "
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 173 L 253.5 175 L 254.5 173 Z "
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 258.5 174 L 261 174.5 L 258.5 175 L 258.5 174 Z "
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 268.5 174 L 272 174.5 L 268.5 175 L 268.5 174 Z "
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 176 L 93 177.5 L 93.5 179 L 95 178.5 L 93.5 180 Q 91.8 176.9 90 178.5 L 93.5 176 Z "
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 180 L 79 182 L 81 181.5 L 80.5 180 Q 83.5 181.5 80.5 183 L 78 181.5 L 78.5 180 Z "
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 183 L 183.5 187 L 183.5 184 Q 185 186.5 186.5 183 Z "
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 184 L 85.5 187 L 83.5 184 Z "
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 184 L 106 186.5 L 105 186.5 L 104.5 184 Z "
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 184 L 191 184.5 Q 188.9 187.8 188.5 184 Z "
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 185 L 100 185.5 L 99.5 188 L 97.5 185 Z "
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 188 L 86.5 191 L 84.5 188 Z "
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 188 L 193 190.5 L 192 190.5 L 192.5 188 Z "
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 191 Q 95 193 91.5 195 L 90 193.5 L 90.5 191 Z "
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 192 L 188.5 194 L 189.5 192 Z "
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 194 L 111.5 196 L 112.5 194 Z "
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 196 L 96 198.5 Q 94 202 92 197.5 L 95 198.5 L 94.5 196 Z "
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 196 L 190 199.5 L 184 198.5 L 187 197.5 L 187.5 196 Z "
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 197 L 88.5 199 L 89.5 197 Z "
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 199 L 183 199.5 Q 183.8 201.8 181.5 201 L 177 203.5 Q 179.3 204.8 176.5 206 L 176.5 204 Q 174.3 204.8 175 202.5 L 177.5 202 L 181 200.5 L 180.5 199 Z "
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 202 L 100 203.5 L 98.5 204 L 97.5 202 Z "
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 202 L 142 202.5 L 139.5 203 L 139.5 202 Z "
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180 203 L 182 203.5 L 179 205.5 L 180 203 Z "
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 204 L 106 205.5 L 104.5 206 L 103.5 204 Z "
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 204 L 182.5 206 L 183.5 204 Z "
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 209 L 163.5 211 L 164.5 209 Z "
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 210 L 132 210.5 L 129.5 211 L 129.5 210 Z "
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,54,106)",
    stroke: "rgb(26,54,106)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 210 L 152 210.5 L 149.5 211 L 149.5 210 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspCore);
export default __webpack_public_path__ + "static/media/ASPCore.c09e8d09b1c1fc399ea613cd42162263.svg";
export { ForwardRef as ReactComponent };